(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));

},{}],2:[function(require,module,exports){
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));

},{}],3:[function(require,module,exports){
/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'desandro-matches-selector/matches-selector'
    ], function( matchesSelector ) {
      return factory( window, matchesSelector );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));

},{"desandro-matches-selector":1}],4:[function(require,module,exports){
// add, remove cell
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'fizzy-ui-utils/utils',
    ], function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {

'use strict';

// append cells to a document fragment
function getCellsFragment( cells ) {
  var fragment = document.createDocumentFragment();
  cells.forEach( function( cell ) {
    fragment.appendChild( cell.element );
  } );
  return fragment;
}

// -------------------------- add/remove cell prototype -------------------------- //

var proto = Flickity.prototype;

/**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */
proto.insert = function( elems, index ) {
  var cells = this._makeCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }
  var len = this.cells.length;
  // default to append
  index = index === undefined ? len : index;
  // add cells with document fragment
  var fragment = getCellsFragment( cells );
  // append to slider
  var isAppend = index == len;
  if ( isAppend ) {
    this.slider.appendChild( fragment );
  } else {
    var insertCellElement = this.cells[ index ].element;
    this.slider.insertBefore( fragment, insertCellElement );
  }
  // add to this.cells
  if ( index === 0 ) {
    // prepend, add to start
    this.cells = cells.concat( this.cells );
  } else if ( isAppend ) {
    // append, add to end
    this.cells = this.cells.concat( cells );
  } else {
    // insert in this.cells
    var endCells = this.cells.splice( index, len - index );
    this.cells = this.cells.concat( cells ).concat( endCells );
  }

  this._sizeCells( cells );
  this.cellChange( index, true );
};

proto.append = function( elems ) {
  this.insert( elems, this.cells.length );
};

proto.prepend = function( elems ) {
  this.insert( elems, 0 );
};

/**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */
proto.remove = function( elems ) {
  var cells = this.getCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }

  var minCellIndex = this.cells.length - 1;
  // remove cells from collection & DOM
  cells.forEach( function( cell ) {
    cell.remove();
    var index = this.cells.indexOf( cell );
    minCellIndex = Math.min( index, minCellIndex );
    utils.removeFrom( this.cells, cell );
  }, this );

  this.cellChange( minCellIndex, true );
};

/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
proto.cellSizeChange = function( elem ) {
  var cell = this.getCell( elem );
  if ( !cell ) {
    return;
  }
  cell.getSize();

  var index = this.cells.indexOf( cell );
  this.cellChange( index );
};

/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */
proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
  var prevSelectedElem = this.selectedElement;
  this._positionCells( changedCellIndex );
  this._getWrapShiftCells();
  this.setGallerySize();
  // update selectedIndex
  // try to maintain position & select previous selected element
  var cell = this.getCell( prevSelectedElem );
  if ( cell ) {
    this.selectedIndex = this.getCellSlideIndex( cell );
  }
  this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );

  this.emitEvent( 'cellChange', [ changedCellIndex ] );
  // position slider
  this.select( this.selectedIndex );
  // do not position slider after lazy load
  if ( isPositioningSlider ) {
    this.positionSliderAtSelected();
  }
};

// -----  ----- //

return Flickity;

} ) );

},{"./flickity":8,"fizzy-ui-utils":3}],5:[function(require,module,exports){
// animate
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'fizzy-ui-utils/utils',
    ], function( utils ) {
      return factory( window, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(
        window,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, utils ) {

'use strict';

// -------------------------- animate -------------------------- //

var proto = {};

proto.startAnimation = function() {
  if ( this.isAnimating ) {
    return;
  }

  this.isAnimating = true;
  this.restingFrames = 0;
  this.animate();
};

proto.animate = function() {
  this.applyDragForce();
  this.applySelectedAttraction();

  var previousX = this.x;

  this.integratePhysics();
  this.positionSlider();
  this.settle( previousX );
  // animate next frame
  if ( this.isAnimating ) {
    var _this = this;
    requestAnimationFrame( function animateFrame() {
      _this.animate();
    } );
  }
};

proto.positionSlider = function() {
  var x = this.x;
  // wrap position around
  if ( this.options.wrapAround && this.cells.length > 1 ) {
    x = utils.modulo( x, this.slideableWidth );
    x -= this.slideableWidth;
    this.shiftWrapCells( x );
  }

  this.setTranslateX( x, this.isAnimating );
  this.dispatchScrollEvent();
};

proto.setTranslateX = function( x, is3d ) {
  x += this.cursorPosition;
  // reverse if right-to-left and using transform
  x = this.options.rightToLeft ? -x : x;
  var translateX = this.getPositionValue( x );
  // use 3D transforms for hardware acceleration on iOS
  // but use 2D when settled, for better font-rendering
  this.slider.style.transform = is3d ?
    'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
};

proto.dispatchScrollEvent = function() {
  var firstSlide = this.slides[0];
  if ( !firstSlide ) {
    return;
  }
  var positionX = -this.x - firstSlide.target;
  var progress = positionX / this.slidesWidth;
  this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
};

proto.positionSliderAtSelected = function() {
  if ( !this.cells.length ) {
    return;
  }
  this.x = -this.selectedSlide.target;
  this.velocity = 0; // stop wobble
  this.positionSlider();
};

proto.getPositionValue = function( position ) {
  if ( this.options.percentPosition ) {
    // percent position, round to 2 digits, like 12.34%
    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 ) + '%';
  } else {
    // pixel positioning
    return Math.round( position ) + 'px';
  }
};

proto.settle = function( previousX ) {
  // keep track of frames where x hasn't moved
  var isResting = !this.isPointerDown &&
      Math.round( this.x * 100 ) == Math.round( previousX * 100 );
  if ( isResting ) {
    this.restingFrames++;
  }
  // stop animating if resting for 3 or more frames
  if ( this.restingFrames > 2 ) {
    this.isAnimating = false;
    delete this.isFreeScrolling;
    // render position with translateX when settled
    this.positionSlider();
    this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
  }
};

proto.shiftWrapCells = function( x ) {
  // shift before cells
  var beforeGap = this.cursorPosition + x;
  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
  // shift after cells
  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
  this._shiftCells( this.afterShiftCells, afterGap, 1 );
};

proto._shiftCells = function( cells, gap, shift ) {
  for ( var i = 0; i < cells.length; i++ ) {
    var cell = cells[i];
    var cellShift = gap > 0 ? shift : 0;
    cell.wrapShift( cellShift );
    gap -= cell.size.outerWidth;
  }
};

proto._unshiftCells = function( cells ) {
  if ( !cells || !cells.length ) {
    return;
  }
  for ( var i = 0; i < cells.length; i++ ) {
    cells[i].wrapShift( 0 );
  }
};

// -------------------------- physics -------------------------- //

proto.integratePhysics = function() {
  this.x += this.velocity;
  this.velocity *= this.getFrictionFactor();
};

proto.applyForce = function( force ) {
  this.velocity += force;
};

proto.getFrictionFactor = function() {
  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
};

proto.getRestingPosition = function() {
  // my thanks to Steven Wittens, who simplified this math greatly
  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
};

proto.applyDragForce = function() {
  if ( !this.isDraggable || !this.isPointerDown ) {
    return;
  }
  // change the position to drag position by applying force
  var dragVelocity = this.dragX - this.x;
  var dragForce = dragVelocity - this.velocity;
  this.applyForce( dragForce );
};

proto.applySelectedAttraction = function() {
  // do not attract if pointer down or no slides
  var dragDown = this.isDraggable && this.isPointerDown;
  if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
    return;
  }
  var distance = this.selectedSlide.target * -1 - this.x;
  var force = distance * this.options.selectedAttraction;
  this.applyForce( force );
};

return proto;

} ) );

},{"fizzy-ui-utils":3}],6:[function(require,module,exports){
// Flickity.Cell
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'get-size/get-size',
    ], function( getSize ) {
      return factory( window, getSize );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('get-size')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(
        window,
        window.getSize
    );
  }

}( window, function factory( window, getSize ) {

'use strict';

function Cell( elem, parent ) {
  this.element = elem;
  this.parent = parent;

  this.create();
}

var proto = Cell.prototype;

proto.create = function() {
  this.element.style.position = 'absolute';
  this.element.setAttribute( 'aria-hidden', 'true' );
  this.x = 0;
  this.shift = 0;
  this.element.style[ this.parent.originSide ] = 0;
};

proto.destroy = function() {
  // reset style
  this.unselect();
  this.element.style.position = '';
  var side = this.parent.originSide;
  this.element.style[ side ] = '';
  this.element.style.transform = '';
  this.element.removeAttribute('aria-hidden');
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

proto.setPosition = function( x ) {
  this.x = x;
  this.updateTarget();
  this.renderPosition( x );
};

// setDefaultTarget v1 method, backwards compatibility, remove in v3
proto.updateTarget = proto.setDefaultTarget = function() {
  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
  this.target = this.x + this.size[ marginProperty ] +
    this.size.width * this.parent.cellAlign;
};

proto.renderPosition = function( x ) {
  // render position of cell with in slider
  var sideOffset = this.parent.originSide === 'left' ? 1 : -1;

  var adjustedX = this.parent.options.percentPosition ?
    x * sideOffset * ( this.parent.size.innerWidth / this.size.width ) :
    x * sideOffset;

  this.element.style.transform = 'translateX(' +
    this.parent.getPositionValue( adjustedX ) + ')';
};

proto.select = function() {
  this.element.classList.add('is-selected');
  this.element.removeAttribute('aria-hidden');
};

proto.unselect = function() {
  this.element.classList.remove('is-selected');
  this.element.setAttribute( 'aria-hidden', 'true' );
};

/**
 * @param {Integer} shift - 0, 1, or -1
 */
proto.wrapShift = function( shift ) {
  this.shift = shift;
  this.renderPosition( this.x + this.parent.slideableWidth * shift );
};

proto.remove = function() {
  this.element.parentNode.removeChild( this.element );
};

return Cell;

} ) );

},{"get-size":15}],7:[function(require,module,exports){
// drag
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'unidragger/unidragger',
      'fizzy-ui-utils/utils',
    ], function( Flickity, Unidragger, utils ) {
      return factory( window, Flickity, Unidragger, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unidragger'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
        window,
        window.Flickity,
        window.Unidragger,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unidragger, utils ) {

'use strict';

// ----- defaults ----- //

utils.extend( Flickity.defaults, {
  draggable: '>1',
  dragThreshold: 3,
} );

// ----- create ----- //

Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

var proto = Flickity.prototype;
utils.extend( proto, Unidragger.prototype );
proto._touchActionValue = 'pan-y';

// --------------------------  -------------------------- //

proto._createDrag = function() {
  this.on( 'activate', this.onActivateDrag );
  this.on( 'uiChange', this._uiChangeDrag );
  this.on( 'deactivate', this.onDeactivateDrag );
  this.on( 'cellChange', this.updateDraggable );
  // TODO updateDraggable on resize? if groupCells & slides change
};

proto.onActivateDrag = function() {
  this.handles = [ this.viewport ];
  this.bindHandles();
  this.updateDraggable();
};

proto.onDeactivateDrag = function() {
  this.unbindHandles();
  this.element.classList.remove('is-draggable');
};

proto.updateDraggable = function() {
  // disable dragging if less than 2 slides. #278
  if ( this.options.draggable == '>1' ) {
    this.isDraggable = this.slides.length > 1;
  } else {
    this.isDraggable = this.options.draggable;
  }
  if ( this.isDraggable ) {
    this.element.classList.add('is-draggable');
  } else {
    this.element.classList.remove('is-draggable');
  }
};

// backwards compatibility
proto.bindDrag = function() {
  this.options.draggable = true;
  this.updateDraggable();
};

proto.unbindDrag = function() {
  this.options.draggable = false;
  this.updateDraggable();
};

proto._uiChangeDrag = function() {
  delete this.isFreeScrolling;
};

// -------------------------- pointer events -------------------------- //

proto.pointerDown = function( event, pointer ) {
  if ( !this.isDraggable ) {
    this._pointerDownDefault( event, pointer );
    return;
  }
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }

  this._pointerDownPreventDefault( event );
  this.pointerDownFocus( event );
  // blur
  if ( document.activeElement != this.element ) {
    // do not blur if already focused
    this.pointerDownBlur();
  }

  // stop if it was moving
  this.dragX = this.x;
  this.viewport.classList.add('is-pointer-down');
  // track scrolling
  this.pointerDownScroll = getScrollPosition();
  window.addEventListener( 'scroll', this );

  this._pointerDownDefault( event, pointer );
};

// default pointerDown logic, used for staticClick
proto._pointerDownDefault = function( event, pointer ) {
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };
  // bind move and end events
  this._bindPostStartEvents( event );
  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
};

var focusNodes = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true,
};

proto.pointerDownFocus = function( event ) {
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isFocusNode ) {
    this.focus();
  }
};

proto._pointerDownPreventDefault = function( event ) {
  var isTouchStart = event.type == 'touchstart';
  var isTouchPointer = event.pointerType == 'touch';
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
    event.preventDefault();
  }
};

// ----- move ----- //

proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > this.options.dragThreshold;
};

// ----- up ----- //

proto.pointerUp = function( event, pointer ) {
  delete this.isTouchScrolling;
  this.viewport.classList.remove('is-pointer-down');
  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
  this._dragPointerUp( event, pointer );
};

proto.pointerDone = function() {
  window.removeEventListener( 'scroll', this );
  delete this.pointerDownScroll;
};

// -------------------------- dragging -------------------------- //

proto.dragStart = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  this.dragStartPosition = this.x;
  this.startAnimation();
  window.removeEventListener( 'scroll', this );
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
};

proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  if ( !this.isDraggable ) {
    return;
  }
  event.preventDefault();

  this.previousDragX = this.dragX;
  // reverse if right-to-left
  var direction = this.options.rightToLeft ? -1 : 1;
  if ( this.options.wrapAround ) {
    // wrap around move. #589
    moveVector.x %= this.slideableWidth;
  }
  var dragX = this.dragStartPosition + moveVector.x * direction;

  if ( !this.options.wrapAround && this.slides.length ) {
    // slow drag
    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
  }

  this.dragX = dragX;

  this.dragMoveTime = new Date();
  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

proto.dragEnd = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  if ( this.options.freeScroll ) {
    this.isFreeScrolling = true;
  }
  // set selectedIndex based on where flick will end up
  var index = this.dragEndRestingSelect();

  if ( this.options.freeScroll && !this.options.wrapAround ) {
    // if free-scroll & not wrap around
    // do not free-scroll if going outside of bounding slides
    // so bounding slides can attract slider, and keep it in bounds
    var restingX = this.getRestingPosition();
    this.isFreeScrolling = -restingX > this.slides[0].target &&
      -restingX < this.getLastSlide().target;
  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
    // boost selection if selected index has not changed
    index += this.dragEndBoostSelect();
  }
  delete this.previousDragX;
  // apply selection
  // TODO refactor this, selecting here feels weird
  // HACK, set flag so dragging stays in correct direction
  this.isDragSelect = this.options.wrapAround;
  this.select( index );
  delete this.isDragSelect;
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

proto.dragEndRestingSelect = function() {
  var restingX = this.getRestingPosition();
  // how far away from selected slide
  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
  // get closet resting going up and going down
  var positiveResting = this._getClosestResting( restingX, distance, 1 );
  var negativeResting = this._getClosestResting( restingX, distance, -1 );
  // use closer resting for wrap-around
  var index = positiveResting.distance < negativeResting.distance ?
    positiveResting.index : negativeResting.index;
  return index;
};

/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
proto._getClosestResting = function( restingX, distance, increment ) {
  var index = this.selectedIndex;
  var minDistance = Infinity;
  var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function( dist, minDist ) {
      return dist <= minDist;
    } : function( dist, minDist ) {
      return dist < minDist;
    };
  while ( condition( distance, minDistance ) ) {
    // measure distance to next cell
    index += increment;
    minDistance = distance;
    distance = this.getSlideDistance( -restingX, index );
    if ( distance === null ) {
      break;
    }
    distance = Math.abs( distance );
  }
  return {
    distance: minDistance,
    // selected was previous index
    index: index - increment,
  };
};

/**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */
proto.getSlideDistance = function( x, index ) {
  var len = this.slides.length;
  // wrap around if at least 2 slides
  var isWrapAround = this.options.wrapAround && len > 1;
  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
  var slide = this.slides[ slideIndex ];
  if ( !slide ) {
    return null;
  }
  // add distance for wrap-around slides
  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index/len ) : 0;
  return x - ( slide.target + wrap );
};

proto.dragEndBoostSelect = function() {
  // do not boost if no previousDragX or dragMoveTime
  if ( this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100 ) {
    return 0;
  }

  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
  var delta = this.previousDragX - this.dragX;
  if ( distance > 0 && delta > 0 ) {
    // boost to next if moving towards the right, and positive velocity
    return 1;
  } else if ( distance < 0 && delta < 0 ) {
    // boost to previous if moving towards the left, and negative velocity
    return -1;
  }
  return 0;
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  // get clickedCell, if cell was clicked
  var clickedCell = this.getParentCell( event.target );
  var cellElem = clickedCell && clickedCell.element;
  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
};

// ----- scroll ----- //

proto.onscroll = function() {
  var scroll = getScrollPosition();
  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
  // cancel click/tap if scroll is too much
  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
    this._pointerDone();
  }
};

// ----- utils ----- //

function getScrollPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset,
  };
}

// -----  ----- //

return Flickity;

} ) );

},{"./flickity":8,"fizzy-ui-utils":3,"unidragger":17}],8:[function(require,module,exports){
// Flickity main
/* eslint-disable max-params */
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'ev-emitter/ev-emitter',
      'get-size/get-size',
      'fizzy-ui-utils/utils',
      './cell',
      './slide',
      './animate',
    ], function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('ev-emitter'),
        require('get-size'),
        require('fizzy-ui-utils'),
        require('./cell'),
        require('./slide'),
        require('./animate')
    );
  } else {
    // browser global
    var _Flickity = window.Flickity;

    window.Flickity = factory(
        window,
        window.EvEmitter,
        window.getSize,
        window.fizzyUIUtils,
        _Flickity.Cell,
        _Flickity.Slide,
        _Flickity.animatePrototype
    );
  }

}( window, function factory( window, EvEmitter, getSize,
    utils, Cell, Slide, animatePrototype ) {

/* eslint-enable max-params */
'use strict';

// vars
var jQuery = window.jQuery;
var getComputedStyle = window.getComputedStyle;
var console = window.console;

function moveElements( elems, toElem ) {
  elems = utils.makeArray( elems );
  while ( elems.length ) {
    toElem.appendChild( elems.shift() );
  }
}

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Flickity intances
var instances = {};

function Flickity( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // do not initialize twice on same element
  if ( this.element.flickityGUID ) {
    var instance = instances[ this.element.flickityGUID ];
    if ( instance ) instance.option( options );
    return instance;
  }

  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }
  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // kick things off
  this._create();
}

Flickity.defaults = {
  accessibility: true,
  // adaptiveHeight: false,
  cellAlign: 'center',
  // cellSelector: undefined,
  // contain: false,
  freeScrollFriction: 0.075, // friction when free-scrolling
  friction: 0.28, // friction when selecting
  namespaceJQueryEvents: true,
  // initialIndex: 0,
  percentPosition: true,
  resize: true,
  selectedAttraction: 0.025,
  setGallerySize: true,
  // watchCSS: false,
  // wrapAround: false
};

// hash of methods triggered on _create()
Flickity.createMethods = [];

var proto = Flickity.prototype;
// inherit EventEmitter
utils.extend( proto, EvEmitter.prototype );

proto._create = function() {
  // add id for Flickity.data
  var id = this.guid = ++GUID;
  this.element.flickityGUID = id; // expando
  instances[ id ] = this; // associate via id
  // initial properties
  this.selectedIndex = 0;
  // how many frames slider has been in same position
  this.restingFrames = 0;
  // initial physics properties
  this.x = 0;
  this.velocity = 0;
  this.originSide = this.options.rightToLeft ? 'right' : 'left';
  // create viewport & slider
  this.viewport = document.createElement('div');
  this.viewport.className = 'flickity-viewport';
  this._createSlider();

  if ( this.options.resize || this.options.watchCSS ) {
    window.addEventListener( 'resize', this );
  }

  // add listeners from on option
  for ( var eventName in this.options.on ) {
    var listener = this.options.on[ eventName ];
    this.on( eventName, listener );
  }

  Flickity.createMethods.forEach( function( method ) {
    this[ method ]();
  }, this );

  if ( this.options.watchCSS ) {
    this.watchCSS();
  } else {
    this.activate();
  }

};

/**
 * set options
 * @param {Object} opts - options to extend
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

proto.activate = function() {
  if ( this.isActive ) {
    return;
  }
  this.isActive = true;
  this.element.classList.add('flickity-enabled');
  if ( this.options.rightToLeft ) {
    this.element.classList.add('flickity-rtl');
  }

  this.getSize();
  // move initial cell elements so they can be loaded as cells
  var cellElems = this._filterFindCellElements( this.element.children );
  moveElements( cellElems, this.slider );
  this.viewport.appendChild( this.slider );
  this.element.appendChild( this.viewport );
  // get cells from children
  this.reloadCells();

  if ( this.options.accessibility ) {
    // allow element to focusable
    this.element.tabIndex = 0;
    // listen for key presses
    this.element.addEventListener( 'keydown', this );
  }

  this.emitEvent('activate');
  this.selectInitialIndex();
  // flag for initial activation, for using initialIndex
  this.isInitActivated = true;
  // ready event. #493
  this.dispatchEvent('ready');
};

// slider positions the cells
proto._createSlider = function() {
  // slider element does all the positioning
  var slider = document.createElement('div');
  slider.className = 'flickity-slider';
  slider.style[ this.originSide ] = 0;
  this.slider = slider;
};

proto._filterFindCellElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.cellSelector );
};

// goes through all children
proto.reloadCells = function() {
  // collection of item elements
  this.cells = this._makeCells( this.slider.children );
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
};

/**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */
proto._makeCells = function( elems ) {
  var cellElems = this._filterFindCellElements( elems );

  // create new Flickity for collection
  var cells = cellElems.map( function( cellElem ) {
    return new Cell( cellElem, this );
  }, this );

  return cells;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.getLastSlide = function() {
  return this.slides[ this.slides.length - 1 ];
};

// positions all cells
proto.positionCells = function() {
  // size all cells
  this._sizeCells( this.cells );
  // position all cells
  this._positionCells( 0 );
};

/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
proto._positionCells = function( index ) {
  index = index || 0;
  // also measure maxCellHeight
  // start 0 if positioning all cells
  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
  var cellX = 0;
  // get cellX
  if ( index > 0 ) {
    var startCell = this.cells[ index - 1 ];
    cellX = startCell.x + startCell.size.outerWidth;
  }
  var len = this.cells.length;
  for ( var i = index; i < len; i++ ) {
    var cell = this.cells[i];
    cell.setPosition( cellX );
    cellX += cell.size.outerWidth;
    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
  }
  // keep track of cellX for wrap-around
  this.slideableWidth = cellX;
  // slides
  this.updateSlides();
  // contain slides target
  this._containSlides();
  // update slidesWidth
  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
};

/**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */
proto._sizeCells = function( cells ) {
  cells.forEach( function( cell ) {
    cell.getSize();
  } );
};

// --------------------------  -------------------------- //

proto.updateSlides = function() {
  this.slides = [];
  if ( !this.cells.length ) {
    return;
  }

  var slide = new Slide( this );
  this.slides.push( slide );
  var isOriginLeft = this.originSide == 'left';
  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

  var canCellFit = this._getCanCellFit();

  this.cells.forEach( function( cell, i ) {
    // just add cell if first cell in slide
    if ( !slide.cells.length ) {
      slide.addCell( cell );
      return;
    }

    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
      ( cell.size.outerWidth - cell.size[ nextMargin ] );

    if ( canCellFit.call( this, i, slideWidth ) ) {
      slide.addCell( cell );
    } else {
      // doesn't fit, new slide
      slide.updateTarget();

      slide = new Slide( this );
      this.slides.push( slide );
      slide.addCell( cell );
    }
  }, this );
  // last slide
  slide.updateTarget();
  // update .selectedSlide
  this.updateSelectedSlide();
};

proto._getCanCellFit = function() {
  var groupCells = this.options.groupCells;
  if ( !groupCells ) {
    return function() {
      return false;
    };
  } else if ( typeof groupCells == 'number' ) {
    // group by number. 3 -> [0,1,2], [3,4,5], ...
    var number = parseInt( groupCells, 10 );
    return function( i ) {
      return ( i % number ) !== 0;
    };
  }
  // default, group by width of slide
  // parse '75%
  var percentMatch = typeof groupCells == 'string' &&
    groupCells.match( /^(\d+)%$/ );
  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
  return function( i, slideWidth ) {
    /* eslint-disable-next-line no-invalid-this */
    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
  };
};

// alias _init for jQuery plugin .flickity()
proto._init =
proto.reposition = function() {
  this.positionCells();
  this.positionSliderAtSelected();
};

proto.getSize = function() {
  this.size = getSize( this.element );
  this.setCellAlign();
  this.cursorPosition = this.size.innerWidth * this.cellAlign;
};

var cellAlignShorthands = {
  // cell align, then based on origin side
  center: {
    left: 0.5,
    right: 0.5,
  },
  left: {
    left: 0,
    right: 1,
  },
  right: {
    right: 0,
    left: 1,
  },
};

proto.setCellAlign = function() {
  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
};

proto.setGallerySize = function() {
  if ( this.options.setGallerySize ) {
    var height = this.options.adaptiveHeight && this.selectedSlide ?
      this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = height + 'px';
  }
};

proto._getWrapShiftCells = function() {
  // only for wrap-around
  if ( !this.options.wrapAround ) {
    return;
  }
  // unshift previous cells
  this._unshiftCells( this.beforeShiftCells );
  this._unshiftCells( this.afterShiftCells );
  // get before cells
  // initial gap
  var gapX = this.cursorPosition;
  var cellIndex = this.cells.length - 1;
  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
  // get after cells
  // ending gap between last cell and end of gallery viewport
  gapX = this.size.innerWidth - this.cursorPosition;
  // start cloning at first cell, working forwards
  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
};

proto._getGapCells = function( gapX, cellIndex, increment ) {
  // keep adding cells until the cover the initial gap
  var cells = [];
  while ( gapX > 0 ) {
    var cell = this.cells[ cellIndex ];
    if ( !cell ) {
      break;
    }
    cells.push( cell );
    cellIndex += increment;
    gapX -= cell.size.outerWidth;
  }
  return cells;
};

// ----- contain ----- //

// contain cell targets so no excess sliding
proto._containSlides = function() {
  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
    return;
  }
  var isRightToLeft = this.options.rightToLeft;
  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
  // content is less than gallery size
  var isContentSmaller = contentWidth < this.size.innerWidth;
  // bounds
  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
  // contain each cell target
  this.slides.forEach( function( slide ) {
    if ( isContentSmaller ) {
      // all cells fit inside gallery
      slide.target = contentWidth * this.cellAlign;
    } else {
      // contain to bounds
      slide.target = Math.max( slide.target, beginBound );
      slide.target = Math.min( slide.target, endBound );
    }
  }, this );
};

// -----  ----- //

/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery && this.$element ) {
    // default trigger with type if no event
    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var $event = type;
    if ( event ) {
      // create jQuery event
      var jQEvent = new jQuery.Event( event );
      jQEvent.type = type;
      $event = jQEvent;
    }
    this.$element.trigger( $event, args );
  }
};

// -------------------------- select -------------------------- //

/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
proto.select = function( index, isWrap, isInstant ) {
  if ( !this.isActive ) {
    return;
  }
  index = parseInt( index, 10 );
  this._wrapSelect( index );

  if ( this.options.wrapAround || isWrap ) {
    index = utils.modulo( index, this.slides.length );
  }
  // bail if invalid index
  if ( !this.slides[ index ] ) {
    return;
  }
  var prevIndex = this.selectedIndex;
  this.selectedIndex = index;
  this.updateSelectedSlide();
  if ( isInstant ) {
    this.positionSliderAtSelected();
  } else {
    this.startAnimation();
  }
  if ( this.options.adaptiveHeight ) {
    this.setGallerySize();
  }
  // events
  this.dispatchEvent( 'select', null, [ index ] );
  // change event if new index
  if ( index != prevIndex ) {
    this.dispatchEvent( 'change', null, [ index ] );
  }
  // old v1 event name, remove in v3
  this.dispatchEvent('cellSelect');
};

// wraps position for wrapAround, to move to closest slide. #113
proto._wrapSelect = function( index ) {
  var len = this.slides.length;
  var isWrapping = this.options.wrapAround && len > 1;
  if ( !isWrapping ) {
    return index;
  }
  var wrapIndex = utils.modulo( index, len );
  // go to shortest
  var delta = Math.abs( wrapIndex - this.selectedIndex );
  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
  if ( !this.isDragSelect && backWrapDelta < delta ) {
    index += len;
  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
    index -= len;
  }
  // wrap position so slider is within normal area
  if ( index < 0 ) {
    this.x -= this.slideableWidth;
  } else if ( index >= len ) {
    this.x += this.slideableWidth;
  }
};

proto.previous = function( isWrap, isInstant ) {
  this.select( this.selectedIndex - 1, isWrap, isInstant );
};

proto.next = function( isWrap, isInstant ) {
  this.select( this.selectedIndex + 1, isWrap, isInstant );
};

proto.updateSelectedSlide = function() {
  var slide = this.slides[ this.selectedIndex ];
  // selectedIndex could be outside of slides, if triggered before resize()
  if ( !slide ) {
    return;
  }
  // unselect previous selected slide
  this.unselectSelectedSlide();
  // update new selected slide
  this.selectedSlide = slide;
  slide.select();
  this.selectedCells = slide.cells;
  this.selectedElements = slide.getCellElements();
  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
  // Remove in v3?
  this.selectedCell = slide.cells[0];
  this.selectedElement = this.selectedElements[0];
};

proto.unselectSelectedSlide = function() {
  if ( this.selectedSlide ) {
    this.selectedSlide.unselect();
  }
};

proto.selectInitialIndex = function() {
  var initialIndex = this.options.initialIndex;
  // already activated, select previous selectedIndex
  if ( this.isInitActivated ) {
    this.select( this.selectedIndex, false, true );
    return;
  }
  // select with selector string
  if ( initialIndex && typeof initialIndex == 'string' ) {
    var cell = this.queryCell( initialIndex );
    if ( cell ) {
      this.selectCell( initialIndex, false, true );
      return;
    }
  }

  var index = 0;
  // select with number
  if ( initialIndex && this.slides[ initialIndex ] ) {
    index = initialIndex;
  }
  // select instantly
  this.select( index, false, true );
};

/**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */
proto.selectCell = function( value, isWrap, isInstant ) {
  // get cell
  var cell = this.queryCell( value );
  if ( !cell ) {
    return;
  }

  var index = this.getCellSlideIndex( cell );
  this.select( index, isWrap, isInstant );
};

proto.getCellSlideIndex = function( cell ) {
  // get index of slides that has cell
  for ( var i = 0; i < this.slides.length; i++ ) {
    var slide = this.slides[i];
    var index = slide.cells.indexOf( cell );
    if ( index != -1 ) {
      return i;
    }
  }
};

// -------------------------- get cells -------------------------- //

/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */
proto.getCell = function( elem ) {
  // loop through cells to get the one that matches
  for ( var i = 0; i < this.cells.length; i++ ) {
    var cell = this.cells[i];
    if ( cell.element == elem ) {
      return cell;
    }
  }
};

/**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */
proto.getCells = function( elems ) {
  elems = utils.makeArray( elems );
  var cells = [];
  elems.forEach( function( elem ) {
    var cell = this.getCell( elem );
    if ( cell ) {
      cells.push( cell );
    }
  }, this );
  return cells;
};

/**
 * get cell elements
 * @returns {Array} cellElems
 */
proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

/**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */
proto.getParentCell = function( elem ) {
  // first check if elem is cell
  var cell = this.getCell( elem );
  if ( cell ) {
    return cell;
  }
  // try to get parent cell elem
  elem = utils.getParent( elem, '.flickity-slider > *' );
  return this.getCell( elem );
};

/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
proto.getAdjacentCellElements = function( adjCount, index ) {
  if ( !adjCount ) {
    return this.selectedSlide.getCellElements();
  }
  index = index === undefined ? this.selectedIndex : index;

  var len = this.slides.length;
  if ( 1 + ( adjCount * 2 ) >= len ) {
    return this.getCellElements();
  }

  var cellElems = [];
  for ( var i = index - adjCount; i <= index + adjCount; i++ ) {
    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
    var slide = this.slides[ slideIndex ];
    if ( slide ) {
      cellElems = cellElems.concat( slide.getCellElements() );
    }
  }
  return cellElems;
};

/**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */
proto.queryCell = function( selector ) {
  if ( typeof selector == 'number' ) {
    // use number as index
    return this.cells[ selector ];
  }
  if ( typeof selector == 'string' ) {
    // do not select invalid selectors from hash: #123, #/. #791
    if ( selector.match( /^[#.]?[\d/]/ ) ) {
      return;
    }
    // use string as selector, get element
    selector = this.element.querySelector( selector );
  }
  // get cell from element
  return this.getCell( selector );
};

// -------------------------- events -------------------------- //

proto.uiChange = function() {
  this.emitEvent('uiChange');
};

// keep focus on element when child UI elements are clicked
proto.childUIPointerDown = function( event ) {
  // HACK iOS does not allow touch events to bubble up?!
  if ( event.type != 'touchstart' ) {
    event.preventDefault();
  }
  this.focus();
};

// ----- resize ----- //

proto.onresize = function() {
  this.watchCSS();
  this.resize();
};

utils.debounceMethod( Flickity, 'onresize', 150 );

proto.resize = function() {
  // #1177 disable resize behavior when animating or dragging for iOS 15
  if ( !this.isActive || this.isAnimating || this.isDragging ) {
    return;
  }
  this.getSize();
  // wrap values
  if ( this.options.wrapAround ) {
    this.x = utils.modulo( this.x, this.slideableWidth );
  }
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent('resize');
  // update selected index for group slides, instant
  // TODO: position can be lost between groups of various numbers
  var selectedElement = this.selectedElements && this.selectedElements[0];
  this.selectCell( selectedElement, false, true );
};

// watches the :after property, activates/deactivates
proto.watchCSS = function() {
  var watchOption = this.options.watchCSS;
  if ( !watchOption ) {
    return;
  }

  var afterContent = getComputedStyle( this.element, ':after' ).content;
  // activate if :after { content: 'flickity' }
  if ( afterContent.indexOf('flickity') != -1 ) {
    this.activate();
  } else {
    this.deactivate();
  }
};

// ----- keydown ----- //

// go previous/next if left/right keys pressed
proto.onkeydown = function( event ) {
  // only work if element is in focus
  var isNotFocused = document.activeElement && document.activeElement != this.element;
  if ( !this.options.accessibility || isNotFocused ) {
    return;
  }

  var handler = Flickity.keyboardHandlers[ event.keyCode ];
  if ( handler ) {
    handler.call( this );
  }
};

Flickity.keyboardHandlers = {
  // left arrow
  37: function() {
    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
    this.uiChange();
    this[ leftMethod ]();
  },
  // right arrow
  39: function() {
    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
    this.uiChange();
    this[ rightMethod ]();
  },
};

// ----- focus ----- //

proto.focus = function() {
  // TODO remove scrollTo once focus options gets more support
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
  //    #Browser_compatibility
  var prevScrollY = window.pageYOffset;
  this.element.focus({ preventScroll: true });
  // hack to fix scroll jump after focus, #76
  if ( window.pageYOffset != prevScrollY ) {
    window.scrollTo( window.pageXOffset, prevScrollY );
  }
};

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
proto.deactivate = function() {
  if ( !this.isActive ) {
    return;
  }
  this.element.classList.remove('flickity-enabled');
  this.element.classList.remove('flickity-rtl');
  this.unselectSelectedSlide();
  // destroy cells
  this.cells.forEach( function( cell ) {
    cell.destroy();
  } );
  this.element.removeChild( this.viewport );
  // move child elements back into element
  moveElements( this.slider.children, this.element );
  if ( this.options.accessibility ) {
    this.element.removeAttribute('tabIndex');
    this.element.removeEventListener( 'keydown', this );
  }
  // set flags
  this.isActive = false;
  this.emitEvent('deactivate');
};

proto.destroy = function() {
  this.deactivate();
  window.removeEventListener( 'resize', this );
  this.allOff();
  this.emitEvent('destroy');
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'flickity' );
  }
  delete this.element.flickityGUID;
  delete instances[ this.guid ];
};

// -------------------------- prototype -------------------------- //

utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

/**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */
Flickity.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.flickityGUID;
  return id && instances[ id ];
};

utils.htmlInit( Flickity, 'flickity' );

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'flickity', Flickity );
}

// set internal jQuery, for Webpack + jQuery v3, #478
Flickity.setJQuery = function( jq ) {
  jQuery = jq;
};

Flickity.Cell = Cell;
Flickity.Slide = Slide;

return Flickity;

} ) );

},{"./animate":5,"./cell":6,"./slide":14,"ev-emitter":2,"fizzy-ui-utils":3,"get-size":15}],9:[function(require,module,exports){
/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      './drag',
      './prev-next-button',
      './page-dots',
      './player',
      './add-remove-cell',
      './lazyload',
    ], factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        require('./flickity'),
        require('./drag'),
        require('./prev-next-button'),
        require('./page-dots'),
        require('./player'),
        require('./add-remove-cell'),
        require('./lazyload')
    );
  }

} )( window, function factory( Flickity ) {
  return Flickity;
} );

},{"./add-remove-cell":4,"./drag":7,"./flickity":8,"./lazyload":10,"./page-dots":11,"./player":12,"./prev-next-button":13}],10:[function(require,module,exports){
// lazyload
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'fizzy-ui-utils/utils',
    ], function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {
'use strict';

Flickity.createMethods.push('_createLazyload');
var proto = Flickity.prototype;

proto._createLazyload = function() {
  this.on( 'select', this.lazyLoad );
};

proto.lazyLoad = function() {
  var lazyLoad = this.options.lazyLoad;
  if ( !lazyLoad ) {
    return;
  }
  // get adjacent cells, use lazyLoad option for adjacent count
  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
  var cellElems = this.getAdjacentCellElements( adjCount );
  // get lazy images in those cells
  var lazyImages = [];
  cellElems.forEach( function( cellElem ) {
    var lazyCellImages = getCellLazyImages( cellElem );
    lazyImages = lazyImages.concat( lazyCellImages );
  } );
  // load lazy images
  lazyImages.forEach( function( img ) {
    new LazyLoader( img, this );
  }, this );
};

function getCellLazyImages( cellElem ) {
  // check if cell element is lazy image
  if ( cellElem.nodeName == 'IMG' ) {
    var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
    var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
    var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
    if ( lazyloadAttr || srcAttr || srcsetAttr ) {
      return [ cellElem ];
    }
  }
  // select lazy images in cell
  var lazySelector = 'img[data-flickity-lazyload], ' +
    'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
  var imgs = cellElem.querySelectorAll( lazySelector );
  return utils.makeArray( imgs );
}

// -------------------------- LazyLoader -------------------------- //

/**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */
function LazyLoader( img, flickity ) {
  this.img = img;
  this.flickity = flickity;
  this.load();
}

LazyLoader.prototype.handleEvent = utils.handleEvent;

LazyLoader.prototype.load = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  // get src & srcset
  var src = this.img.getAttribute('data-flickity-lazyload') ||
    this.img.getAttribute('data-flickity-lazyload-src');
  var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
  // set src & serset
  this.img.src = src;
  if ( srcset ) {
    this.img.setAttribute( 'srcset', srcset );
  }
  // remove attr
  this.img.removeAttribute('data-flickity-lazyload');
  this.img.removeAttribute('data-flickity-lazyload-src');
  this.img.removeAttribute('data-flickity-lazyload-srcset');
};

LazyLoader.prototype.onload = function( event ) {
  this.complete( event, 'flickity-lazyloaded' );
};

LazyLoader.prototype.onerror = function( event ) {
  this.complete( event, 'flickity-lazyerror' );
};

LazyLoader.prototype.complete = function( event, className ) {
  // unbind events
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );

  var cell = this.flickity.getParentCell( this.img );
  var cellElem = cell && cell.element;
  this.flickity.cellSizeChange( cellElem );

  this.img.classList.add( className );
  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
};

// -----  ----- //

Flickity.LazyLoader = LazyLoader;

return Flickity;

} ) );

},{"./flickity":8,"fizzy-ui-utils":3}],11:[function(require,module,exports){
// page dots
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'unipointer/unipointer',
      'fizzy-ui-utils/utils',
    ], function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unipointer'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.Unipointer,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unipointer, utils ) {

// -------------------------- PageDots -------------------------- //

'use strict';

function PageDots( parent ) {
  this.parent = parent;
  this._create();
}

PageDots.prototype = Object.create( Unipointer.prototype );

PageDots.prototype._create = function() {
  // create holder element
  this.holder = document.createElement('ol');
  this.holder.className = 'flickity-page-dots';
  // create dots, array of elements
  this.dots = [];
  // events
  this.handleClick = this.onClick.bind( this );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PageDots.prototype.activate = function() {
  this.setDots();
  this.holder.addEventListener( 'click', this.handleClick );
  this.bindStartEvent( this.holder );
  // add to DOM
  this.parent.element.appendChild( this.holder );
};

PageDots.prototype.deactivate = function() {
  this.holder.removeEventListener( 'click', this.handleClick );
  this.unbindStartEvent( this.holder );
  // remove from DOM
  this.parent.element.removeChild( this.holder );
};

PageDots.prototype.setDots = function() {
  // get difference between number of slides and number of dots
  var delta = this.parent.slides.length - this.dots.length;
  if ( delta > 0 ) {
    this.addDots( delta );
  } else if ( delta < 0 ) {
    this.removeDots( -delta );
  }
};

PageDots.prototype.addDots = function( count ) {
  var fragment = document.createDocumentFragment();
  var newDots = [];
  var length = this.dots.length;
  var max = length + count;

  for ( var i = length; i < max; i++ ) {
    var dot = document.createElement('li');
    dot.className = 'dot';
    dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
    fragment.appendChild( dot );
    newDots.push( dot );
  }

  this.holder.appendChild( fragment );
  this.dots = this.dots.concat( newDots );
};

PageDots.prototype.removeDots = function( count ) {
  // remove from this.dots collection
  var removeDots = this.dots.splice( this.dots.length - count, count );
  // remove from DOM
  removeDots.forEach( function( dot ) {
    this.holder.removeChild( dot );
  }, this );
};

PageDots.prototype.updateSelected = function() {
  // remove selected class on previous
  if ( this.selectedDot ) {
    this.selectedDot.className = 'dot';
    this.selectedDot.removeAttribute('aria-current');
  }
  // don't proceed if no dots
  if ( !this.dots.length ) {
    return;
  }
  this.selectedDot = this.dots[ this.parent.selectedIndex ];
  this.selectedDot.className = 'dot is-selected';
  this.selectedDot.setAttribute( 'aria-current', 'step' );
};

PageDots.prototype.onTap = // old method name, backwards-compatible
PageDots.prototype.onClick = function( event ) {
  var target = event.target;
  // only care about dot clicks
  if ( target.nodeName != 'LI' ) {
    return;
  }

  this.parent.uiChange();
  var index = this.dots.indexOf( target );
  this.parent.select( index );
};

PageDots.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pageDots: true,
} );

Flickity.createMethods.push('_createPageDots');

var proto = Flickity.prototype;

proto._createPageDots = function() {
  if ( !this.options.pageDots ) {
    return;
  }
  this.pageDots = new PageDots( this );
  // events
  this.on( 'activate', this.activatePageDots );
  this.on( 'select', this.updateSelectedPageDots );
  this.on( 'cellChange', this.updatePageDots );
  this.on( 'resize', this.updatePageDots );
  this.on( 'deactivate', this.deactivatePageDots );
};

proto.activatePageDots = function() {
  this.pageDots.activate();
};

proto.updateSelectedPageDots = function() {
  this.pageDots.updateSelected();
};

proto.updatePageDots = function() {
  this.pageDots.setDots();
};

proto.deactivatePageDots = function() {
  this.pageDots.deactivate();
};

// -----  ----- //

Flickity.PageDots = PageDots;

return Flickity;

} ) );

},{"./flickity":8,"fizzy-ui-utils":3,"unipointer":18}],12:[function(require,module,exports){
// player & autoPlay
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'ev-emitter/ev-emitter',
      'fizzy-ui-utils/utils',
      './flickity',
    ], function( EvEmitter, utils, Flickity ) {
      return factory( EvEmitter, utils, Flickity );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        require('ev-emitter'),
        require('fizzy-ui-utils'),
        require('./flickity')
    );
  } else {
    // browser global
    factory(
        window.EvEmitter,
        window.fizzyUIUtils,
        window.Flickity
    );
  }

}( window, function factory( EvEmitter, utils, Flickity ) {

'use strict';

// -------------------------- Player -------------------------- //

function Player( parent ) {
  this.parent = parent;
  this.state = 'stopped';
  // visibility change event handler
  this.onVisibilityChange = this.visibilityChange.bind( this );
  this.onVisibilityPlay = this.visibilityPlay.bind( this );
}

Player.prototype = Object.create( EvEmitter.prototype );

// start play
Player.prototype.play = function() {
  if ( this.state == 'playing' ) {
    return;
  }
  // do not play if page is hidden, start playing when page is visible
  var isPageHidden = document.hidden;
  if ( isPageHidden ) {
    document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
    return;
  }

  this.state = 'playing';
  // listen to visibility change
  document.addEventListener( 'visibilitychange', this.onVisibilityChange );
  // start ticking
  this.tick();
};

Player.prototype.tick = function() {
  // do not tick if not playing
  if ( this.state != 'playing' ) {
    return;
  }

  var time = this.parent.options.autoPlay;
  // default to 3 seconds
  time = typeof time == 'number' ? time : 3000;
  var _this = this;
  // HACK: reset ticks if stopped and started within interval
  this.clear();
  this.timeout = setTimeout( function() {
    _this.parent.next( true );
    _this.tick();
  }, time );
};

Player.prototype.stop = function() {
  this.state = 'stopped';
  this.clear();
  // remove visibility change event
  document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
};

Player.prototype.clear = function() {
  clearTimeout( this.timeout );
};

Player.prototype.pause = function() {
  if ( this.state == 'playing' ) {
    this.state = 'paused';
    this.clear();
  }
};

Player.prototype.unpause = function() {
  // re-start play if paused
  if ( this.state == 'paused' ) {
    this.play();
  }
};

// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange = function() {
  var isPageHidden = document.hidden;
  this[ isPageHidden ? 'pause' : 'unpause' ]();
};

Player.prototype.visibilityPlay = function() {
  this.play();
  document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
};

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pauseAutoPlayOnHover: true,
} );

Flickity.createMethods.push('_createPlayer');
var proto = Flickity.prototype;

proto._createPlayer = function() {
  this.player = new Player( this );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) {
    return;
  }
  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// ----- mouseenter/leave ----- //

// pause auto-play on hover
proto.onmouseenter = function() {
  if ( !this.options.pauseAutoPlayOnHover ) {
    return;
  }
  this.player.pause();
  this.element.addEventListener( 'mouseleave', this );
};

// resume auto-play on hover off
proto.onmouseleave = function() {
  this.player.unpause();
  this.element.removeEventListener( 'mouseleave', this );
};

// -----  ----- //

Flickity.Player = Player;

return Flickity;

} ) );

},{"./flickity":8,"ev-emitter":2,"fizzy-ui-utils":3}],13:[function(require,module,exports){
// prev/next buttons
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'unipointer/unipointer',
      'fizzy-ui-utils/utils',
    ], function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unipointer'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.Unipointer,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unipointer, utils ) {
'use strict';

var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

function PrevNextButton( direction, parent ) {
  this.direction = direction;
  this.parent = parent;
  this._create();
}

PrevNextButton.prototype = Object.create( Unipointer.prototype );

PrevNextButton.prototype._create = function() {
  // properties
  this.isEnabled = true;
  this.isPrevious = this.direction == -1;
  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
  this.isLeft = this.direction == leftDirection;

  var element = this.element = document.createElement('button');
  element.className = 'flickity-button flickity-prev-next-button';
  element.className += this.isPrevious ? ' previous' : ' next';
  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
  element.setAttribute( 'type', 'button' );
  // init as disabled
  this.disable();

  element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );

  // create arrow
  var svg = this.createSVG();
  element.appendChild( svg );
  // events
  this.parent.on( 'select', this.update.bind( this ) );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PrevNextButton.prototype.activate = function() {
  this.bindStartEvent( this.element );
  this.element.addEventListener( 'click', this );
  // add to DOM
  this.parent.element.appendChild( this.element );
};

PrevNextButton.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.element );
  // click events
  this.unbindStartEvent( this.element );
  this.element.removeEventListener( 'click', this );
};

PrevNextButton.prototype.createSVG = function() {
  var svg = document.createElementNS( svgURI, 'svg' );
  svg.setAttribute( 'class', 'flickity-button-icon' );
  svg.setAttribute( 'viewBox', '0 0 100 100' );
  var path = document.createElementNS( svgURI, 'path' );
  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
  path.setAttribute( 'd', pathMovements );
  path.setAttribute( 'class', 'arrow' );
  // rotate arrow
  if ( !this.isLeft ) {
    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
  }
  svg.appendChild( path );
  return svg;
};

// get SVG path movmement
function getArrowMovements( shape ) {
  // use shape as movement if string
  if ( typeof shape == 'string' ) {
    return shape;
  }
  // create movement string
  return 'M ' + shape.x0 + ',50' +
    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
    ' L ' + shape.x3 + ',50 ' +
    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
    ' Z';
}

PrevNextButton.prototype.handleEvent = utils.handleEvent;

PrevNextButton.prototype.onclick = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.parent.uiChange();
  var method = this.isPrevious ? 'previous' : 'next';
  this.parent[ method ]();
};

// -----  ----- //

PrevNextButton.prototype.enable = function() {
  if ( this.isEnabled ) {
    return;
  }
  this.element.disabled = false;
  this.isEnabled = true;
};

PrevNextButton.prototype.disable = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.element.disabled = true;
  this.isEnabled = false;
};

PrevNextButton.prototype.update = function() {
  // index of first or last slide, if previous or next
  var slides = this.parent.slides;
  // enable is wrapAround and at least 2 slides
  if ( this.parent.options.wrapAround && slides.length > 1 ) {
    this.enable();
    return;
  }
  var lastIndex = slides.length ? slides.length - 1 : 0;
  var boundIndex = this.isPrevious ? 0 : lastIndex;
  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
  this[ method ]();
};

PrevNextButton.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

// -------------------------- Flickity prototype -------------------------- //

utils.extend( Flickity.defaults, {
  prevNextButtons: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30,
  },
} );

Flickity.createMethods.push('_createPrevNextButtons');
var proto = Flickity.prototype;

proto._createPrevNextButtons = function() {
  if ( !this.options.prevNextButtons ) {
    return;
  }

  this.prevButton = new PrevNextButton( -1, this );
  this.nextButton = new PrevNextButton( 1, this );

  this.on( 'activate', this.activatePrevNextButtons );
};

proto.activatePrevNextButtons = function() {
  this.prevButton.activate();
  this.nextButton.activate();
  this.on( 'deactivate', this.deactivatePrevNextButtons );
};

proto.deactivatePrevNextButtons = function() {
  this.prevButton.deactivate();
  this.nextButton.deactivate();
  this.off( 'deactivate', this.deactivatePrevNextButtons );
};

// --------------------------  -------------------------- //

Flickity.PrevNextButton = PrevNextButton;

return Flickity;

} ) );

},{"./flickity":8,"fizzy-ui-utils":3,"unipointer":18}],14:[function(require,module,exports){
// slide
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }

}( window, function factory() {
'use strict';

function Slide( parent ) {
  this.parent = parent;
  this.isOriginLeft = parent.originSide == 'left';
  this.cells = [];
  this.outerWidth = 0;
  this.height = 0;
}

var proto = Slide.prototype;

proto.addCell = function( cell ) {
  this.cells.push( cell );
  this.outerWidth += cell.size.outerWidth;
  this.height = Math.max( cell.size.outerHeight, this.height );
  // first cell stuff
  if ( this.cells.length == 1 ) {
    this.x = cell.x; // x comes from first cell
    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
    this.firstMargin = cell.size[ beginMargin ];
  }
};

proto.updateTarget = function() {
  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
  var lastCell = this.getLastCell();
  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.select = function() {
  this.cells.forEach( function( cell ) {
    cell.select();
  } );
};

proto.unselect = function() {
  this.cells.forEach( function( cell ) {
    cell.unselect();
  } );
};

proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

return Slide;

} ) );

},{}],15:[function(require,module,exports){
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});

},{}],16:[function(require,module,exports){
/*!
 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

(function(root, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  }
  else if (typeof exports === 'object') {
    // COMMONJS
    module.exports = factory();
  }
  else {
    // BROWSER
    root.Headroom = factory();
  }
}(this, function() {
  'use strict';

  /* exported features */
  
  var features = {
    bind : !!(function(){}.bind),
    classList : 'classList' in document.documentElement,
    rAF : !!(window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame)
  };
  window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  
  /**
   * Handles debouncing of events via requestAnimationFrame
   * @see http://www.html5rocks.com/en/tutorials/speed/animations/
   * @param {Function} callback The callback to handle whichever event
   */
  function Debouncer (callback) {
    this.callback = callback;
    this.ticking = false;
  }
  Debouncer.prototype = {
    constructor : Debouncer,
  
    /**
     * dispatches the event to the supplied callback
     * @private
     */
    update : function() {
      this.callback && this.callback();
      this.ticking = false;
    },
  
    /**
     * ensures events don't get stacked
     * @private
     */
    requestTick : function() {
      if(!this.ticking) {
        requestAnimationFrame(this.rafCallback || (this.rafCallback = this.update.bind(this)));
        this.ticking = true;
      }
    },
  
    /**
     * Attach this as the event listeners
     */
    handleEvent : function() {
      this.requestTick();
    }
  };
  /**
   * Check if object is part of the DOM
   * @constructor
   * @param {Object} obj element to check
   */
  function isDOMElement(obj) {
    return obj && typeof window !== 'undefined' && (obj === window || obj.nodeType);
  }
  
  /**
   * Helper function for extending objects
   */
  function extend (object /*, objectN ... */) {
    if(arguments.length <= 0) {
      throw new Error('Missing arguments in extend function');
    }
  
    var result = object || {},
        key,
        i;
  
    for (i = 1; i < arguments.length; i++) {
      var replacement = arguments[i] || {};
  
      for (key in replacement) {
        // Recurse into object except if the object is a DOM element
        if(typeof result[key] === 'object' && ! isDOMElement(result[key])) {
          result[key] = extend(result[key], replacement[key]);
        }
        else {
          result[key] = result[key] || replacement[key];
        }
      }
    }
  
    return result;
  }
  
  /**
   * Helper function for normalizing tolerance option to object format
   */
  function normalizeTolerance (t) {
    return t === Object(t) ? t : { down : t, up : t };
  }
  
  /**
   * UI enhancement for fixed headers.
   * Hides header when scrolling down
   * Shows header when scrolling up
   * @constructor
   * @param {DOMElement} elem the header element
   * @param {Object} options options for the widget
   */
  function Headroom (elem, options) {
    options = extend(options, Headroom.options);
  
    this.lastKnownScrollY = 0;
    this.elem             = elem;
    this.tolerance        = normalizeTolerance(options.tolerance);
    this.classes          = options.classes;
    this.offset           = options.offset;
    this.scroller         = options.scroller;
    this.initialised      = false;
    this.onPin            = options.onPin;
    this.onUnpin          = options.onUnpin;
    this.onTop            = options.onTop;
    this.onNotTop         = options.onNotTop;
    this.onBottom         = options.onBottom;
    this.onNotBottom      = options.onNotBottom;
  }
  Headroom.prototype = {
    constructor : Headroom,
  
    /**
     * Initialises the widget
     */
    init : function() {
      if(!Headroom.cutsTheMustard) {
        return;
      }
  
      this.debouncer = new Debouncer(this.update.bind(this));
      this.elem.classList.add(this.classes.initial);
  
      // defer event registration to handle browser
      // potentially restoring previous scroll position
      setTimeout(this.attachEvent.bind(this), 100);
  
      return this;
    },
  
    /**
     * Unattaches events and removes any classes that were added
     */
    destroy : function() {
      var classes = this.classes;
  
      this.initialised = false;
  
      for (var key in classes) {
        if(classes.hasOwnProperty(key)) {
          this.elem.classList.remove(classes[key]);
        }
      }
  
      this.scroller.removeEventListener('scroll', this.debouncer, false);
    },
  
    /**
     * Attaches the scroll event
     * @private
     */
    attachEvent : function() {
      if(!this.initialised){
        this.lastKnownScrollY = this.getScrollY();
        this.initialised = true;
        this.scroller.addEventListener('scroll', this.debouncer, false);
  
        this.debouncer.handleEvent();
      }
    },
  
    /**
     * Unpins the header if it's currently pinned
     */
    unpin : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(classList.contains(classes.pinned) || !classList.contains(classes.unpinned)) {
        classList.add(classes.unpinned);
        classList.remove(classes.pinned);
        this.onUnpin && this.onUnpin.call(this);
      }
    },
  
    /**
     * Pins the header if it's currently unpinned
     */
    pin : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(classList.contains(classes.unpinned)) {
        classList.remove(classes.unpinned);
        classList.add(classes.pinned);
        this.onPin && this.onPin.call(this);
      }
    },
  
    /**
     * Handles the top states
     */
    top : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.top)) {
        classList.add(classes.top);
        classList.remove(classes.notTop);
        this.onTop && this.onTop.call(this);
      }
    },
  
    /**
     * Handles the not top state
     */
    notTop : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.notTop)) {
        classList.add(classes.notTop);
        classList.remove(classes.top);
        this.onNotTop && this.onNotTop.call(this);
      }
    },
  
    bottom : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.bottom)) {
        classList.add(classes.bottom);
        classList.remove(classes.notBottom);
        this.onBottom && this.onBottom.call(this);
      }
    },
  
    /**
     * Handles the not top state
     */
    notBottom : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.notBottom)) {
        classList.add(classes.notBottom);
        classList.remove(classes.bottom);
        this.onNotBottom && this.onNotBottom.call(this);
      }
    },
  
    /**
     * Gets the Y scroll position
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY
     * @return {Number} pixels the page has scrolled along the Y-axis
     */
    getScrollY : function() {
      return (this.scroller.pageYOffset !== undefined)
        ? this.scroller.pageYOffset
        : (this.scroller.scrollTop !== undefined)
          ? this.scroller.scrollTop
          : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    },
  
    /**
     * Gets the height of the viewport
     * @see http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
     * @return {int} the height of the viewport in pixels
     */
    getViewportHeight : function () {
      return window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
    },
  
    /**
     * Gets the physical height of the DOM element
     * @param  {Object}  elm the element to calculate the physical height of which
     * @return {int}     the physical height of the element in pixels
     */
    getElementPhysicalHeight : function (elm) {
      return Math.max(
        elm.offsetHeight,
        elm.clientHeight
      );
    },
  
    /**
     * Gets the physical height of the scroller element
     * @return {int} the physical height of the scroller element in pixels
     */
    getScrollerPhysicalHeight : function () {
      return (this.scroller === window || this.scroller === document.body)
        ? this.getViewportHeight()
        : this.getElementPhysicalHeight(this.scroller);
    },
  
    /**
     * Gets the height of the document
     * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
     * @return {int} the height of the document in pixels
     */
    getDocumentHeight : function () {
      var body = document.body,
        documentElement = document.documentElement;
  
      return Math.max(
        body.scrollHeight, documentElement.scrollHeight,
        body.offsetHeight, documentElement.offsetHeight,
        body.clientHeight, documentElement.clientHeight
      );
    },
  
    /**
     * Gets the height of the DOM element
     * @param  {Object}  elm the element to calculate the height of which
     * @return {int}     the height of the element in pixels
     */
    getElementHeight : function (elm) {
      return Math.max(
        elm.scrollHeight,
        elm.offsetHeight,
        elm.clientHeight
      );
    },
  
    /**
     * Gets the height of the scroller element
     * @return {int} the height of the scroller element in pixels
     */
    getScrollerHeight : function () {
      return (this.scroller === window || this.scroller === document.body)
        ? this.getDocumentHeight()
        : this.getElementHeight(this.scroller);
    },
  
    /**
     * determines if the scroll position is outside of document boundaries
     * @param  {int}  currentScrollY the current y scroll position
     * @return {bool} true if out of bounds, false otherwise
     */
    isOutOfBounds : function (currentScrollY) {
      var pastTop  = currentScrollY < 0,
        pastBottom = currentScrollY + this.getScrollerPhysicalHeight() > this.getScrollerHeight();
  
      return pastTop || pastBottom;
    },
  
    /**
     * determines if the tolerance has been exceeded
     * @param  {int} currentScrollY the current scroll y position
     * @return {bool} true if tolerance exceeded, false otherwise
     */
    toleranceExceeded : function (currentScrollY, direction) {
      return Math.abs(currentScrollY-this.lastKnownScrollY) >= this.tolerance[direction];
    },
  
    /**
     * determine if it is appropriate to unpin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should unpin, false otherwise
     */
    shouldUnpin : function (currentScrollY, toleranceExceeded) {
      var scrollingDown = currentScrollY > this.lastKnownScrollY,
        pastOffset = currentScrollY >= this.offset;
  
      return scrollingDown && pastOffset && toleranceExceeded;
    },
  
    /**
     * determine if it is appropriate to pin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should pin, false otherwise
     */
    shouldPin : function (currentScrollY, toleranceExceeded) {
      var scrollingUp  = currentScrollY < this.lastKnownScrollY,
        pastOffset = currentScrollY <= this.offset;
  
      return (scrollingUp && toleranceExceeded) || pastOffset;
    },
  
    /**
     * Handles updating the state of the widget
     */
    update : function() {
      var currentScrollY  = this.getScrollY(),
        scrollDirection = currentScrollY > this.lastKnownScrollY ? 'down' : 'up',
        toleranceExceeded = this.toleranceExceeded(currentScrollY, scrollDirection);
  
      if(this.isOutOfBounds(currentScrollY)) { // Ignore bouncy scrolling in OSX
        return;
      }
  
      if (currentScrollY <= this.offset ) {
        this.top();
      } else {
        this.notTop();
      }
  
      if(currentScrollY + this.getViewportHeight() >= this.getScrollerHeight()) {
        this.bottom();
      }
      else {
        this.notBottom();
      }
  
      if(this.shouldUnpin(currentScrollY, toleranceExceeded)) {
        this.unpin();
      }
      else if(this.shouldPin(currentScrollY, toleranceExceeded)) {
        this.pin();
      }
  
      this.lastKnownScrollY = currentScrollY;
    }
  };
  /**
   * Default options
   * @type {Object}
   */
  Headroom.options = {
    tolerance : {
      up : 0,
      down : 0
    },
    offset : 0,
    scroller: window,
    classes : {
      pinned : 'headroom--pinned',
      unpinned : 'headroom--unpinned',
      top : 'headroom--top',
      notTop : 'headroom--not-top',
      bottom : 'headroom--bottom',
      notBottom : 'headroom--not-bottom',
      initial : 'headroom'
    }
  };
  Headroom.cutsTheMustard = typeof features !== 'undefined' && features.rAF && features.bind && features.classList;

  return Headroom;
}));
},{}],17:[function(require,module,exports){
/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'unipointer/unipointer'
    ], function( Unipointer ) {
      return factory( window, Unipointer );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.Unidragger = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {

'use strict';

// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd
 */
proto._bindHandles = function( isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  // bind each handle
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
  var touchAction = isAdd ? this._touchActionValue : '';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isAdd );
    handle[ bindMethod ]( 'click', this );
    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
    if ( window.PointerEvent ) {
      handle.style.touchAction = touchAction;
    }
  }
};

// prototype so it can be overwriteable by Flickity
proto._touchActionValue = 'none';

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };

  event.preventDefault();
  this.pointerDownBlur();
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  SELECT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

// dismiss inputs with text fields. flickity#403, flickity#404
proto.okayPointerDown = function( event ) {
  var isCursorNode = cursorNodes[ event.target.nodeName ];
  var isClickType = clickTypes[ event.target.type ];
  var isOkay = !isCursorNode || isClickType;
  if ( !isOkay ) {
    this._pointerReset();
  }
  return isOkay;
};

// kludge to blur previously focused input
proto.pointerDownBlur = function() {
  var focused = document.activeElement;
  // do not blur body for IE10, metafizzy/flickity#117
  var canBlur = focused && focused.blur && focused != document.body;
  if ( canBlur ) {
    focused.blur();
  }
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var moveVector = {
    x: pointer.pageX - this.pointerDownPointer.pageX,
    y: pointer.pageY - this.pointerDownPointer.pageY
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};

// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  // prevent clicks
  this.isPreventingClicks = true;
  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));

},{"unipointer":18}],18:[function(require,module,exports){
/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'ev-emitter/ev-emitter'
    ], function( EvEmitter ) {
      return factory( window, EvEmitter );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.Unipointer = factory(
      window,
      window.EvEmitter
    );
  }

}( window, function factory( window, EvEmitter ) {

'use strict';

function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */
proto._bindStartEvent = function( elem, isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

  // default to mouse events
  var startEvent = 'mousedown';
  if ( 'ontouchstart' in window ) {
    // HACK prefer Touch Events as you can preventDefault on touchstart to
    // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
    startEvent = 'touchstart';
  } else if ( window.PointerEvent ) {
    // Pointer Events
    startEvent = 'pointerdown';
  }
  elem[ bindMethod ]( startEvent, this );
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss right click and other pointers
  // button = 0 is okay, 1-4 not
  if ( event.button || this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  this._pointerReset();
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto._pointerReset = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));

},{"ev-emitter":2}],19:[function(require,module,exports){
'use strict';

(function (window) {

    'use strict';

    require('./app/prototypes');

    require('./app/variables');

    require('./app/util-helper');

    require('./app/homepage');

    require('./app/professionals');

    require('./app/professional-detail');

    require('./app/capabilities');

    require('./app/capability-detail');

    require('./app/experiences');

    require('./app/about');

    require('./app/general-content');

    require('./app/locations');

    require('./app/location-detail');

    require('./app/articles-landing');

    require('./app/article-detail');

    require('./app/site-search-results');

    require('./app/contact-us');

    require('./app/careers');

    require('./app/topic-detail');

    require('./lg-home');

    require('./app/lazy-load').init();

    require('./app/global-solutions');

    require('./app/perspectives-detail');
})(window);

},{"./app/about":20,"./app/article-detail":24,"./app/articles-landing":25,"./app/capabilities":28,"./app/capability-detail":29,"./app/careers":31,"./app/contact-us":33,"./app/experiences":35,"./app/general-content":36,"./app/global-solutions":39,"./app/homepage":41,"./app/lazy-load":43,"./app/location-detail":44,"./app/locations":48,"./app/perspectives-detail":50,"./app/professional-detail":51,"./app/professionals":52,"./app/prototypes":53,"./app/site-search-results":61,"./app/topic-detail":65,"./app/util-helper":66,"./app/variables":67,"./lg-home":71}],20:[function(require,module,exports){
'use strict';

module.exports = function () {
  var aboutLanding = document.getElementById('about-landing');

  if (!aboutLanding) {
    return;
  }

  //include large polygon;
  require('./angled-polygon');

  //return for garbage collection
  aboutLanding = null;
}();

},{"./angled-polygon":22}],21:[function(require,module,exports){
'use strict';

function Accordions($accordion, optionsLogic) {
    this.$accordionModule = $accordion;
    this.$accordionSlides = null;
    this.$accordionNodes = null;
    this.options = optionsLogic || {
        exclusive: false,
        duration: 350, //in ms,
        triggerClass: 'js-accordion-trigger',
        accordionContentClass: 'js-accordion-content',
        parentClass: 'js-accordion-node',
        activeClass: 'is-expanded',
        accordionTitleLink: 'js-accordion-node-link',
        expandedByDefault: 'js-expanded-by-default'
    };

    this.bindEvents();
    this.init();
}

Accordions.prototype.init = function init() {
    var _self = this;
    _self.$accordionNodes = _self.$accordionModule.find('.' + _self.options.parentClass);
    _self.$accordionSlides = _self.$accordionModule.find('.' + _self.options.accordionContentClass);
    _self.openExpandedByDefault();
};

Accordions.prototype.openExpandedByDefault = function openExpandedByDefault() {
    var _self = this;

    var expandedByDefaultAccordions = _self.$accordionModule.find("." + _self.options.expandedByDefault);
    var triggers = expandedByDefaultAccordions.find("." + _self.options.triggerClass);

    triggers.trigger("click.Accordions");
};

Accordions.prototype.collapseAll = function collaseAll() {
    this.$accordionNodes.removeClass(this.options.activeClass);

    this.$accordionNodes.each(function (index, el) {
        $(el).find('.' + this.options.triggerClass).attr('aria-expanded', 'false').end().find('.' + this.options.accordionContentClass).attr('aria-hidden', true);
    });
};

Accordions.prototype.sendToAccordionTitleUrl = function sendToAccordionTitleUrl($accordionTitleElement) {
    if ($accordionTitleElement.length) {
        var titleUrl = $accordionTitleElement.data("url");
        if (titleUrl.length) window.location.href = titleUrl;
    }
};

Accordions.prototype.collapseAccordion = function collapse($accordion, $trigger) {
    var _self = this;

    //Collapse Accordion Content, 
    var $collapseContent = $accordion.find('.' + this.options.accordionContentClass),

    // get the height of the element's inner content, regardless of its actual size
    sectionHeight = $collapseContent[0].scrollHeight;

    requestAnimationFrame(function () {
        $collapseContent.height(sectionHeight + 'px');

        requestAnimationFrame(function () {
            $collapseContent.height(0 + 'px');
        });
    });

    $collapseContent[0].addEventListener('transitionend', function (e) {
        // remove this event listener so it only gets triggered once
        $collapseContent[0].removeEventListener('transitionend', void 0);

        // remove "height" from the element's inline styles, so it can return to its initial value
        $collapseContent.css('height', '').attr('aria-hidden', true).attr('tabindex', -1);

        $accordion.removeClass(_self.options.activeClass);
    });

    //aria attribute updates
    if ($trigger.length) {
        $trigger.attr('aria-expanded', 'false');

        var ariaLabel = $trigger.attr('aria-label');
        $trigger.attr('aria-label', ariaLabel.replace('Collapse', 'Expand'));
    } else {
        var $trigger = $accordion.find('.' + this.options.triggerClass);
        var ariaLabel = $trigger.attr('aria-label');

        $trigger.attr('aria-expanded', 'false').attr('aria-label', ariaLabel.replace('Collapse', 'Expand'));
    }
};

Accordions.prototype.expandAccordion = function expand($accordion, $trigger) {
    if (this.options.exclusive) {
        this.collapseAll();
    }

    var _self = this;

    //Expand Accordion Content, 
    var $collapseContent = $accordion.find('.' + this.options.accordionContentClass),

    // get the height of the element's inner content, regardless of its actual size
    sectionHeight = $collapseContent[0].scrollHeight;

    requestAnimationFrame(function () {
        $collapseContent.height(sectionHeight + 'px');
    });

    $collapseContent[0].addEventListener('transitionend', function (e) {
        // remove this event listener so it only gets triggered once
        $collapseContent[0].removeEventListener('transitionend', void 0);

        // remove "height" from the element's inline styles, so it can return to its initial value
        $collapseContent.css('height', '').attr('aria-hidden', false).attr('tabindex', 1);

        $accordion.addClass(_self.options.activeClass);
    });

    if ($trigger.length) {
        $trigger.attr('aria-expanded', 'true');

        var ariaLabel = $trigger.attr('aria-label');
        $trigger.attr('aria-label', ariaLabel.replace('Expand', 'Collapse'));
    } else {
        var $trigger = $accordion.find('.' + this.options.triggerClass);
        var ariaLabel = $trigger.attr('aria-label');
        $trigger.attr('aria-expanded', 'true').attr('aria-label', ariaLabel.replace('Expand', 'Collapse'));
    }
};

Accordions.prototype.toggleVisibility = function toggle($trigger) {
    var $parentNode = $trigger.closest('.' + this.options.parentClass);

    $parentNode.hasClass(this.options.activeClass) ? this.collapseAccordion($parentNode, $trigger) : this.expandAccordion($parentNode, $trigger);
};

Accordions.prototype.bindEvents = function bindEvents() {
    var _self = this;

    //initialize events
    _self.$accordionModule.on('click.Accordions', '.' + _self.options.triggerClass, function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        _self.toggleVisibility($(this));
    });

    _self.$accordionModule.on('click.Accordions', '.' + _self.options.accordionTitleLink, function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        _self.sendToAccordionTitleUrl($(this));
    });

    //if accordion is exclusive, we cache elements for future use
    if (_self.options.exclusive) {
        _self.$accordionSlides = _self.$accordionModule.find('.' + _self.options.accordionContentClass);
        _self.$accordionNodes = _self.$accordionModule.find('.' + _self.options.parentClass);
    }
};

module.exports = Accordions;

},{}],22:[function(require,module,exports){
'use strict';

$(function () {
  var svg = document.getElementById('angled-polygon-svg'),
      module = document.getElementById('angled-polygon'),
      advancedFilters = document.getElementById('advanced-filters-categories'),


  //images
  polygonImgBlack = document.getElementById('angled-polygon-black-img'),
      polygonImgRed = document.getElementById('angled-polygon-red-img'),


  //Polygons that we will modify, depending if the content extend a certain threshold or if we are on mobile
  svgPolygonPoints = document.getElementById('angled-polygon-points'),
      svgPolygonPointsRed = document.getElementById('angled-polygon-points-red'),
      cachedSvgPolygonPoints = !!svgPolygonPoints && svgPolygonPoints.hasAttribute('points') ? svgPolygonPoints.getAttribute('points') : '',
      cachedSvgPolygonPointsRed = !!svgPolygonPointsRed && svgPolygonPointsRed.hasAttribute('points') ? svgPolygonPointsRed.getAttribute('points') : '',


  //content
  domContent = document.getElementById('angled-hero-body'),
      isMobile = false,
      pWidth = !!polygonImgRed ? polygonImgRed.getAttribute('width') : 0,
      pHeight = !!polygonImgRed ? polygonImgRed.getAttribute('height') : 0,
      imageAspectRatio = pWidth / pHeight;

  var largeDesktopBreakpoint = 1300;

  var svgAnglePadding, horizontalOffsetTriangle, polygonBlackOffsetY, polygonRedOffsetX;

  //utility functions
  var emConversion = function emConversion(pixelVal) {
    return Math.ceil(pixelVal / 16) + 'em';
  };

  var computeDegreesToRadians = function computeDegreesToRadians(degree) {
    return degree * Math.PI / 180;
  };

  var composePolygonPoints = function composePolygonPoints(polygonSvg, dimensions) {

    if (!!polygonSvg) {
      polygonSvg.setAttribute('points', dimensions.width + ' 0 ' + dimensions.width + ' ' + dimensions.pointRightEdge + ' ' + dimensions.pointMiddleEdgeX + ' ' + dimensions.pointMiddleEdge + ' 0 ' + dimensions.pointLeftEdge + ' 0 0');
    }
  };

  var setPolygonSizeBlack = function setPolygonSizeBlack(svgWidth, svgHeight) {

    var polygonSvg = document.getElementById('angled-polygon-points');

    var dimensions = {
      width: svgWidth - 30, //15 padding on both sides,
      height: svgHeight - polygonBlackOffsetY,
      pointRightEdge: 0,
      pointMiddleEdge: 0,
      pointMiddleEdgeX: horizontalOffsetTriangle,
      pointLeftEdge: 0
    };

    dimensions.pointLeftEdge = horizontalOffsetTriangle * Math.sin(computeDegreesToRadians(10.029)) / Math.sin(computeDegreesToRadians(79));

    dimensions.pointRightEdge = (dimensions.width - horizontalOffsetTriangle) * Math.sin(computeDegreesToRadians(10.029)) / Math.sin(computeDegreesToRadians(79));

    dimensions.pointLeftEdge = svgHeight - dimensions.pointLeftEdge - polygonBlackOffsetY;

    dimensions.pointRightEdge = svgHeight - dimensions.pointRightEdge - polygonBlackOffsetY;

    dimensions.pointMiddleEdge = svgHeight - polygonBlackOffsetY;

    if (window.innerWidth < largeDesktopBreakpoint) {
      composePolygonPoints(polygonSvg, dimensions);
    } else if (!!polygonSvg) {
      polygonSvg.setAttribute('points', cachedSvgPolygonPoints);
    }
  };

  var setPolygonSizeRed = function setPolygonSizeRed(svgWidth, svgHeight) {

    var polygonSvg = document.getElementById('angled-polygon-points-red'),
        polygonGroup = document.getElementById('angled-polygon-red-face');

    var dimensions = {
      width: svgWidth - 30 - polygonRedOffsetX * 2, //15 padding on both sides, 26 triangle inset
      height: svgHeight,
      pointRightEdge: 0,
      pointMiddleEdge: 0,
      pointMiddleEdgeX: horizontalOffsetTriangle - polygonRedOffsetX,
      pointLeftEdge: 0
    };

    dimensions.pointLeftEdge = dimensions.pointMiddleEdgeX * Math.sin(computeDegreesToRadians(10.029)) / Math.sin(computeDegreesToRadians(79));

    dimensions.pointRightEdge = (dimensions.width - dimensions.pointMiddleEdgeX) * Math.sin(computeDegreesToRadians(10.029)) / Math.sin(computeDegreesToRadians(79));

    dimensions.pointLeftEdge = svgHeight - dimensions.pointLeftEdge;

    dimensions.pointRightEdge = svgHeight - dimensions.pointRightEdge;

    dimensions.pointMiddleEdge = svgHeight;

    if (window.innerWidth < largeDesktopBreakpoint) {
      composePolygonPoints(polygonSvg, dimensions);

      if (!!polygonGroup) {
        polygonGroup.setAttribute('transform', 'translate(' + (polygonRedOffsetX + 15) + ', 0)');
      }

      if (!!polygonImgRed) {
        polygonImgRed.setAttribute('x', polygonRedOffsetX * -1);
      }
    } else {

      if (!!polygonSvg) {
        polygonSvg.setAttribute('points', cachedSvgPolygonPointsRed);
      }

      if (!!polygonGroup) {
        polygonGroup.setAttribute('transform', 'translate(' + polygonGroup.getAttribute('data-transform') + ')');
      }

      if (!!polygonImgRed) {
        polygonImgRed.setAttribute('x', polygonImgRed.getAttribute('data-offset-x'));
      }
    }
  };

  var setImageDimensions = function setImageDimensions(svgWidth, svgHeight) {

    if (!!polygonImgRed && polygonImgRed.getAttribute('height') > svgHeight) {
      return;
    }

    var newDimensions;

    if (svgWidth / svgHeight < imageAspectRatio) {
      newDimensions = {
        height: svgHeight,
        width: imageAspectRatio * svgHeight
      };
    } else {
      newDimensions = {
        height: imageAspectRatio / svgWidth,
        width: svgWidth
      };
    }

    if (!!polygonImgBlack) {
      polygonImgBlack.setAttribute('width', newDimensions.width);
      polygonImgBlack.setAttribute('height', newDimensions.height);
    }

    if (!!polygonImgRed) {
      polygonImgRed.setAttribute('width', newDimensions.width);
      polygonImgRed.setAttribute('height', newDimensions.height);
    }
  };

  var setupMeasurements = function setupMeasurements() {
    isMobile = window.innerWidth < 900 ? true : false;

    svgAnglePadding = isMobile ? 160 : 280, horizontalOffsetTriangle = isMobile ? 60 : 140, polygonBlackOffsetY = isMobile ? 24 : 65, polygonRedOffsetX = isMobile ? 15 : 26;
  };

  var resizeDesktop = function resizeDesktop() {

    setupMeasurements();

    var contentHeight = domContent.getBoundingClientRect().bottom + window.pageYOffset,
        svgWidth = window.innerWidth + 30,
        svgHeight = contentHeight + svgAnglePadding;

    //determine if advanced filters are present on page and we are in tablet more
    if (!!advancedFilters && window.innerWidth < 900) {
      contentHeight = contentHeight + advancedFilters.scrollHeight;
      svgHeight = contentHeight + svgAnglePadding;
    }

    if (window.innerWidth < largeDesktopBreakpoint) {
      if (!!svg) {
        svg.setAttribute('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight);
      }
      if (!!module) {
        module.setAttribute('class', 'angled-polygon full-width');
        module.setAttribute('style', 'height: ' + emConversion(svgHeight - 5));
      }
    } else {
      if (!!svg) {
        svg.setAttribute('viewBox', svg.getAttribute('default-viewbox'));
      }

      if (!!module) {
        module.setAttribute('class', 'angled-polygon');
        module.removeAttribute('style');
      }
    }

    setPolygonSizeBlack(svgWidth, svgHeight);

    setPolygonSizeRed(svgWidth, svgHeight);

    setImageDimensions(svgWidth, svgHeight);
  };

  resizeDesktop();

  window.addEventListener('resize', resizeDesktop);

  window.resizeSVGHero = resizeDesktop;
});

},{}],23:[function(require,module,exports){
'use strict';

var animationSearchHelpers,
    pageConfig,
    timeoutDelay = 750,
    $loadingScreen,
    $appliedFilters,
    globalVars = require('./variables'),
    cachedElements = globalVars.elementStates;

animationSearchHelpers = {
	slideToSearchResults: function slideToSearchResults() {

		var searchForm,
		    filtersOffset,
		    _self = this;

		searchForm = !!pageConfig.searchFormID ? document.getElementById(pageConfig.searchFormID) : document.getElementById('search-landing-filters');

		//compute offset of searchFilters
		filtersOffset = parseInt(searchForm.getBoundingClientRect().bottom + window.pageYOffset, 10);

		filtersOffset = Math.ceil(filtersOffset);

		$('html,body').animate({
			scrollTop: filtersOffset
		}, 500, function () {
			// _self.focusOnSearchResults();
		});

		searchForm = null;
	},
	applySelectedFilter: function applySelectedFilter(filterName) {

		var $htmlFilter = $('<li class="applied-filters-item js-filter">' + filterName + '<button aria-label="Remove Filter ' + filterName + '" class="applied-filters-remove js-remove-filter"></button>' + '</div>');

		console.log('klsdjkl');

		$htmlFilter.prependTo($appliedFilters);
	},
	focusOnSearchResults: function focusOnSearchResults() {
		var searchResultsContent = document.getElementById(pageConfig.searchResultsID);

		$(searchResultsContent).focus();

		searchResultsContent = null;
	},
	cacheElements: function cacheElements() {

		var resultsDOM = !!pageConfig.searchResultsID ? document.getElementById(pageConfig.searchResultsID) : document.getElementById('search-entity-landing-results');

		$appliedFilters = $(resultsDOM).find('.js-applied-filters');

		resultsDOM = null;
	},
	init: function init(pageConfiguration) {
		pageConfig = pageConfiguration;

		//back to top init
		if (pageConfiguration != null) {
			pageConfig = pageConfiguration;
		} else {
			pageConfig = {};
		}

		this.cacheElements();
	},
	showLoadingScreen: function showLoadingScreen() {
		$loadingScreen.addClass('show-loading-screen');
	},
	hideLoadingScreen: function hideLoadingScreen() {
		$loadingScreen.removeClass('show-loading-screen');
	},
	transitionFromDefaultToResults: function transitionFromDefaultToResults() {
		var defaultContent,
		    _self = this;

		defaultContent = !!pageConfig.searchPromoPanelID ? document.getElementById(pageConfig.searchPromoPanelID) : document.getElementById('search-landing-default');

		// this.showLoadingScreen();

		if (!!defaultContent) {

			$(defaultContent).fadeOut('slow', function () {
				$(this).attr({
					'aria-hidden': true,
					'tabIndex': -1
				});

				_self.showSearchResults();

				defaultContent = null;
			});
		} else {
			_self.showSearchResults();
		}
	},
	showSearchResults: function showSearchResults() {
		var resultsBody,
		    _self = this;

		resultsBody = !!pageConfig.searchResultsID ? document.getElementById(pageConfig.searchResultsID) : document.getElementById('search-landing-results');

		if (resultsBody.getAttribute('aria-hidden') === 'true') {

			$(resultsBody).fadeIn('fast', function () {

				$(this).attr({
					'aria-hidden': false,
					'tabIndex': 0
				});

				_self.slideToSearchResults();

				//_self.hideLoadingScreen();
			});

			resultsBody = null;
		} else {

			_self.slideToSearchResults();

			resultsBody = null;

			//setTimeout(_self.hideLoadingScreen, timeoutDelay);
		}
	},
	transitionToSearchDefault: function transitionToSearchDefault() {

		var resultsBody,
		    defaultContent,
		    timeoutID,
		    keywordEntrySectionOffset,
		    siteHeaderHeight,
		    _self = this;

		defaultContent = !!pageConfig.defaultContentID ? document.getElementById(pageConfig.defaultContentID) : false;
		resultsBody = !!pageConfig.searchResultsID ? document.getElementById(pageConfig.searchResultsID) : document.getElementById('search-landing-results');

		this.showLoadingScreen();

		siteHeaderHeight = $('.js-site-header').outerHeight();
		keywordEntrySectionOffset = $('.js-entity-search-control').offset();

		$('html,body').animate({
			scrollTop: keywordEntrySectionOffset ? keywordEntrySectionOffset.top - siteHeaderHeight : 0
		}, timeoutDelay);

		//if default content exists on the page, then we will fade out the current display and fade in the respected content
		if (!!defaultContent) {
			$(resultsBody).slideUp(timeoutDelay, function () {
				$(this).attr({
					'aria-hidden': true,
					'tabIndex': -1
				});

				_self.hideLoadingScreen();

				$(defaultContent).fadeIn('fast', function () {

					$(this).attr({
						'aria-hidden': false,
						'tabIndex': 0
					});

					resultsBody = defaultContent = null;
				});
			});
		} else {
			//default content doesnt exist so we simply scroll to thte top and hide the loading screen;

			setTimeout(function () {
				_self.hideLoadingScreen();
			}, timeoutDelay);
		}
	}
};

module.exports = animationSearchHelpers;

},{"./variables":67}],24:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var articleDetail = document.getElementById('article-detail'),


  //modules
  ReadMore;

  if (!articleDetail) {
    return;
  }

  /**Read More**/
  ReadMore = require('./read-more');
  var readMoreNode = $(articleDetail).find('.js-read-more');
  if (readMoreNode.length) {
    new ReadMore(readMoreNode);
  }
  /**Read More**/

  window.stickyShare = require('./sticky-share');

  window.stickyShare.init();

  //return for garbage collection
  articleDetail = null;
}();

},{"./read-more":54,"./sticky-share":63}],25:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var articlesLanding = document.getElementById('articles-landing'),


  //modules
  pageOptions,
      searchLandingFilters,
      impactfulCTA,
      selectDropdowns;

  if (!articlesLanding) {
    return;
  }

  pageOptions = {
    pageName: 'articles-landing',
    searchPromoPanelID: 'search-entity-landing-promo',
    searchResultsID: 'search-entity-landing-results'
  };

  //attach helpers to window, and allow acccess  animation interactivity within custom framework(ex. angularJS,knockout.js)
  window.animationSearchHelpers = require('./animation-search-helpers');
  window.animationSearchHelpers.init(pageOptions);

  //BackEnd Developers can overwrite floowing Search landing filters, only for template specific behavior
  searchLandingFilters = require('./search-landing-filters');
  searchLandingFilters.init(pageOptions);

  //initiate selectdropdowns
  selectDropdowns = require('./select-dropdown');

  var $dropdowns = $(articlesLanding).find('.js-select-dropdown');

  selectDropdowns($dropdowns, function selectDropdownCallback($selectEl, $selectedItem) {

    if (!!$selectedItem) {
      window.animationSearchHelpers.applySelectedFilter($selectedItem.text());
    }
  });

  impactfulCTA = require('./impactful-cta');

  $(function () {
    impactfulCTA.init();
  });

  //include large polygon;
  require('./angled-polygon');

  //return for garbage collection
  articlesLanding = $dropdowns = null;
}();

},{"./angled-polygon":22,"./animation-search-helpers":23,"./impactful-cta":42,"./search-landing-filters":58,"./select-dropdown":59}],26:[function(require,module,exports){
'use strict';

function BuildVideoPlayer($youtubeVideos, pageOptions) {
    var player,
        currentVideoId,
        $playerContainer = $('.js-video-player'),
        $closeButton = $('.js-close-video'),
        $restrictedFocusElements = [$('#site-header *'), $('.skip-to'), $('.main-content *'), $('.site-footer *')],
        activePlayerClass = 'show-video-player',
        firstLoad = true;

    var $initialVideoHighlight = $youtubeVideos.first();

    loadAPI();

    if ($initialVideoHighlight.attr('data-youtube-id')) {
        currentVideoId = $initialVideoHighlight.data('youtube-id');
        window.onYouTubeIframeAPIReady = function () {
            player = new YT.Player('video-iframe', {
                videoId: currentVideoId,
                frameborder: 0,
                height: '390',
                width: '640',
                playerVars: { autoplay: 0, showinfo: 0 },
                events: {
                    'onReady': function onReady() {},
                    'onStateChange': function onStateChange() {}
                }
            });
        };
    }

    $youtubeVideos.on('click', handleContainerClick);
    $closeButton.on('click', closeVideo);
    $playerContainer.on('click', function (event) {
        if ($(event.target).hasClass('js-video-player')) {
            event.stopPropagation();
            closeVideo();
        }
    });

    function loadAPI() {
        var firstScriptTag;
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function handleContainerClick(event) {
        var youtubeId = event.currentTarget.dataset.youtubeId;
        if (youtubeId) {
            if (youtubeId !== currentVideoId) {
                currentVideoId = youtubeId;
                player.loadVideoById({ 'videoId': currentVideoId });
                openVideo();
            } else {
                openVideo();
            }
        }
    }

    function openVideo() {
        player.playVideo();
        if (firstLoad) {
            setTimeout(function () {
                displayVideoContainer();
                firstLoad = false;
            }, 200);
        } else {
            displayVideoContainer();
        }
    }

    function closeVideo(event) {
        $playerContainer.removeClass(activePlayerClass);
        $('body').removeClass('lock-scroll');
        reinstateFocus();
        player.pauseVideo();
    }

    function displayVideoContainer() {
        $playerContainer.addClass(activePlayerClass);
        $('body').addClass('lock-scroll');
        restrictFocus();
    }

    function restrictFocus() {
        if ($restrictedFocusElements) {
            $restrictedFocusElements.forEach(function (elem) {
                $(elem).attr('tabindex', -1);
            });
        }

        if (pageOptions && pageOptions.animatedSections) {
            pageOptions.animatedSections.forEach(function (section) {
                var $section = $(section);
                $section.addClass(pageOptions.pauseTransitionClass);
            });
        }
    }

    function reinstateFocus() {
        if ($restrictedFocusElements) {
            $restrictedFocusElements.forEach(function (elem) {
                $(elem).removeAttr('tabindex');
            });
        }

        if (pageOptions && pageOptions.animatedSections) {
            pageOptions.animatedSections.forEach(function (section) {
                var $section = $(section);
                $section.removeClass(pageOptions.pauseTransitionClass);
            });
        }
    }
}

module.exports = BuildVideoPlayer;

},{}],27:[function(require,module,exports){
'use strict';

var $capabilitiesCompact,
    $viewMoreToggle,
    childrenToShow,
    animationClass = 'animate-in',
    isChildrenExpanded = false,


//Module Exports
capabilitiesCompact;

capabilitiesCompact = {

	expandChildren: function expandChildren() {

		$viewMoreToggle.find('.btn-ghost-label').text($capabilitiesCompact.data('label-less'));

		$capabilitiesCompact.find('.listing-capabilities-option__read-more').slideDown();

		isChildrenExpanded = true;
	},
	collapseChildren: function collapseChildren() {
		$viewMoreToggle.find('.btn-ghost-label').text($capabilitiesCompact.data('label-more'));

		$capabilitiesCompact.find('.listing-capabilities-option__read-more').slideUp();

		isChildrenExpanded = false;
	},
	toggleView: function toggleView() {
		isChildrenExpanded ? this.collapseChildren() : this.expandChildren();
	},
	initScrollToggle: function initScrollToggle() {

		var _self = this;

		$viewMoreToggle.on('click', function (ev) {
			ev.preventDefault();
			ev.stopPropagation();

			_self.toggleView();
		});
	},
	init: function init($wrapper) {

		//initialize Variables
		$capabilitiesCompact = $wrapper || $('.capabilities-compact');

		$viewMoreToggle = $capabilitiesCompact.find('.btn-text-load-more');

		childrenToShow = $capabilitiesCompact.data('child-selector') || 3;

		this.initScrollToggle();
	}
};

module.exports = capabilitiesCompact;

},{}],28:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var capabilities = document.getElementById('capabilities-landing'),


  // modules
  pageOptions,
      searchLandingFilters,
      Accordion,
      Scrollspy,
      impactfulCTA,
      selectDropdowns;

  if (!capabilities) {
    return;
  }

  pageOptions = {
    pageName: 'capabilities-landing',
    searchPromoPanelID: 'search-entity-landing-promo',
    searchResultsID: 'search-entity-landing-results',
    alphaSearch: false
  };

  // Initialize scrollspy
  Scrollspy = require('./scrollspy');
  // Initializing without $window.ready doesn't work here for some reason
  $(window).ready(function () {
    Scrollspy.init();
  });

  // attach helpers to window, and allow acccess  animation interactivity within custom framework(ex. angularJS,knockout.js)
  window.animationSearchHelpers = require('./animation-search-helpers');
  window.animationSearchHelpers.init(pageOptions);

  // initialize credentials accordion if it exists
  var $credentialsAccordion = $(capabilities).find('.js-accordion');
  if ($credentialsAccordion.length) {
    Accordion = require('./accordion');
    new Accordion($credentialsAccordion);
  }

  // BackEnd Developers can overwrite floowing Search landing filters, only for template specific behavior
  searchLandingFilters = require('./search-landing-filters');
  searchLandingFilters.init(pageOptions);

  // include large polygon;
  require('./angled-polygon');

  impactfulCTA = require('./impactful-cta');
  $(function () {
    impactfulCTA.init();
  });

  //return for garbage collection
  capabilities = null;
}();

},{"./accordion":21,"./angled-polygon":22,"./animation-search-helpers":23,"./impactful-cta":42,"./scrollspy":57,"./search-landing-filters":58}],29:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var capabilityDetail = document.getElementById('capability-detail'),
      ReadMore,
      Accordion,
      SliderCarousel,
      Scrollspy,
      BuildVideoPlayer;

  if (!capabilityDetail) {
    return;
  }

  // Initialize overview
  ReadMore = require('./read-more');
  var readMoreNode = $(capabilityDetail).find('.js-read-more');

  if (readMoreNode.length) {
    new ReadMore(readMoreNode);
  }

  // Initialize overview
  SliderCarousel = require('./slider-carousel');
  var carouselNode = $(capabilityDetail).find('.js-slider-carousel');

  if (carouselNode.length) {
    new SliderCarousel(carouselNode);
  }

  // Initialize credentials accordion if it exists
  Accordion = require('./accordion');
  var $focusAreas = $(capabilityDetail).find('.js-accordion');

  if ($focusAreas.length) {
    new Accordion($focusAreas);
  }

  // Initialize scrollspy
  Scrollspy = require('./scrollspy');
  Scrollspy.init();

  // Initialize video player
  var $youtubeVideos = $('.js-youtube-video');
  if ($youtubeVideos.length) {
    BuildVideoPlayer = require('./build-video-player');
    BuildVideoPlayer($youtubeVideos);
  }

  // Scroll page on load
  require('./scroll-on-load');

  //return for garbage collection
  capabilityDetail = readMoreNode = null;
}();

},{"./accordion":21,"./build-video-player":26,"./read-more":54,"./scroll-on-load":56,"./scrollspy":57,"./slider-carousel":62}],30:[function(require,module,exports){
'use strict';

var searchFiltersForm, pageOptions, $clearAll, focusableSelector, CareersGCFilters;

CareersGCFilters = {

    handleContentDisplay: function handleContentDisplay() {
        var searchResultsContent = document.getElementById(pageOptions.searchResultsID);

        searchResultsContent.getAttribute('aria-hidden') === 'true' ? window.animationSearchHelpers.transitionFromDefaultToResults() : window.animationSearchHelpers.showSearchResults();

        searchResultsContent = null;
    },

    initClearAllEvent: function initClearAllEvent() {
        $clearAll.on('click.clearResults', function (ev) {
            ev.stopPropagation();
            window.animationSearchHelpers.transitionToSearchDefault();
        });
    },

    transitionToSearchDefault: function transitionToSearchDefault() {
        window.animationSearchHelpers.transitionToSearchDefault();
    },

    advancedSearchInit: function advancedSearchInit() {
        var $advancedFilters = $(searchFiltersForm).find('.js-advanced-filters');

        $advancedFilters.on('click', '.js-categories-trigger', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();

            $(this).toggleClass('is-expanded');
        });
    },

    initSubmitEvent: function initSubmitEvent() {
        var _self = this;

        $(searchFiltersForm).submit(function (ev) {
            ev.preventDefault();

            _self.handleContentDisplay();
        });
    },

    // $('');

    setDropdownAccessibility: function setDropdownAccessibility() {
        var tablet = window.matchMedia('(max-width: 56.1875em)');
        if (tablet.matches) {
            $('.js-categories').attr('aria-hidden', true).find(focusableSelector).attr('tabindex', -1);
        } else {
            $('.js-categories').attr('aria-hidden', false).find(focusableSelector).attr('tabindex', 0);
        }
    },

    init: function init(pageConfig) {
        if (!pageConfig) {
            console.log('invalid argument, need Object supplied');
        }

        pageOptions = pageConfig;
        pageOptions.searchFormID = pageOptions.searchFormID || 'search-landing-filters';

        searchFiltersForm = document.getElementById(pageOptions.searchFormID);

        // Assign jQuery elements
        focusableSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

        this.initSubmitEvent();
        this.advancedSearchInit();
        this.setDropdownAccessibility();
        $(window).resize(this.setDropdownAccessibility);

        var _self = this;
    }
};

module.exports = CareersGCFilters;

},{}],31:[function(require,module,exports){
'use strict';

// YouTube Videos

var BuildVideoPlayer = require('./build-video-player');
var $youtubeVideos = $('.video-header-play-button.js-youtube-video');

if ($youtubeVideos.length) {
  BuildVideoPlayer = require('./build-video-player');
  BuildVideoPlayer($youtubeVideos);
}

// Vertical Scrolling for Page Blocks
var $pageBlocks = $('#page-blocks');
if ($pageBlocks.length) {
  var verticalCorner = require('./vertical-corner');
  verticalCorner.init();
}

// Hover State for Featured CTA Buttons
var $featuredCtas = $('#featured-ctas');
if ($featuredCtas.length) {
  var impactfulCTA = require('./impactful-cta');
  $(function () {
    impactfulCTA.init();
  });
};

// Accordion Buckets
var $accordionBuckets = $('.js-accordion');
if ($accordionBuckets.length) {
  var Accordion = require('./accordion');
  $accordionBuckets.each(function (index, el) {
    new Accordion($(el));
  });
}

var pageOptions = {
  pageName: 'careers-gc',
  searchResultsID: 'careers-gc-results'
};
//BackEnd Developers can overwrite floowing Search landing filters, only for template specific behavior
var careersGCFilters = require('./careers-gc-filters');
careersGCFilters.init(pageOptions);

// School Interview Search
var $schoolSearch = $('.school-interview');
//if ($schoolSearch.length) {
//    var SchoolSearch = require('./school-search');
//    $schoolSearch.each(function (index, el) {
//        new SchoolSearch($(el));
//    });
//}

// Side Nav
var sideNav = require('./sidenav');
sideNav.init();

// Read More
var ReadMore = require('./read-more');
var $readMore = $('.js-read-more');
if ($readMore.length) {
  new ReadMore($readMore);
}

},{"./accordion":21,"./build-video-player":26,"./careers-gc-filters":30,"./impactful-cta":42,"./read-more":54,"./sidenav":60,"./vertical-corner":68}],32:[function(require,module,exports){
'use strict';

module.exports = function () {

	var initFormLogic, inquiryTypeShow, selectDropdown, $contactUsForm, $inquiryDropdown;

	inquiryTypeShow = function inquiryTypeShow($selectEl, $selectedItem) {

		//For Template Purposes

		$contactUsForm.find('.form-message-send').slideDown();
	};

	initFormLogic = function initFormLogic($form) {

		$contactUsForm = !!$form ? $form : $('.js-contact-us-form');

		selectDropdown = require('./select-dropdown');

		$inquiryDropdown = $contactUsForm.find('.js-inquiry-dropdown');

		selectDropdown($inquiryDropdown, inquiryTypeShow);
	};

	return {
		init: initFormLogic
	};
}();

},{"./select-dropdown":59}],33:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var contactUs = document.getElementById('contact-us-page'),


  //modules
  contactUsForm;

  if (!contactUs) {
    return;
  }

  contactUsForm = require('./contact-us-form');

  contactUsForm.init($(contactUs).find('.js-contact-us-form'));

  //return for garbage collection
  contactUs = null;
}();

},{"./contact-us-form":32}],34:[function(require,module,exports){
'use strict';

var dynamicTabs,
// Module imports
globalVars, windowResize;

// Global variables
globalVars = require('./variables');

windowResize = globalVars.windowResize;

var keys = {
	left: 37,
	up: 38,
	right: 39,
	down: 40
};

var directions = {};
directions[keys.left] = -1;
directions[keys.up] = -1;
directions[keys.right] = 1;
directions[keys.down] = 1;

dynamicTabs = {
	updateNavigation: function updateNavigation(clickedNavNode) {
		//clear all nav items
		this.$tabsNav.find('.' + this.options.tabActiveClass).removeClass(this.options.tabActiveClass).children();

		//setActiveNode
		this.$tabButtons.attr({ 'aria-selected': false, 'tabindex': -1 });
		$(clickedNavNode).attr({ 'aria-selected': true, 'tabindex': 0 }).parent().addClass(this.options.tabActiveClass);
	},
	resetClasses: function resetClasses($activePanel) {
		this.$tabs.removeClass(this.options.transitionOutClass).find('.' + this.options.beltWrapperClass).css('height', '');

		$activePanel.removeClass(this.options.transitionInClass).addClass(this.options.panelActiveClass);

		this.isAnimating = false;
	},
	transitionActivePanel: function transitionActivePanel() {
		var _self = this,
		    $activePanel = $('#' + this.activePanelID),
		    $beltWrapper = _self.$tabs.find('.' + _self.options.beltWrapperClass);

		//find current active panel and remove class
		this.$tabs.find('.' + this.options.panelActiveClass).removeClass(this.options.panelActiveClass).attr({
			'aria-hidden': true,
			'aria-expanded': false,
			'tabindex': '-1'
		}).find('a, button').attr('tabindex', -1);

		$activePanel.addClass(this.options.transitionInClass).attr({
			'aria-hidden': false,
			'aria-expanded': true,
			'tabindex': '0'
		}).find('a, button').attr('tabindex', 0);

		$beltWrapper.css('height', $activePanel.height() + 'px');

		setTimeout(function () {
			_self.resetClasses($activePanel);
			_self = null;
		}, this.options.transitionTiming);

		$beltWrapper = null;
	},
	transitionPanel: function transitionPanel() {
		var _self = this,
		    $beltWrapper = _self.$tabs.find('.' + _self.options.beltWrapperClass);

		this.$tabs.addClass(_self.options.transitionOutClass);

		$beltWrapper.css('height', $beltWrapper.height() + 'px');

		setTimeout(function () {
			_self.transitionActivePanel($beltWrapper);
			_self = null;
		}, this.options.transitionTiming);

		$beltWrapper = null;
	},
	showNextPanel: function showNextPanel(navNode, wasAutomatic) {
		var panelID = navNode.getAttribute('href');

		this.activePanelID = panelID.slice(1);

		this.isAnimating = true;

		this.transitionPanel();

		this.updateNavigation(navNode);

		if (!wasAutomatic) {
			navNode.focus();
		}

		if (typeof this.options.callback === 'function') {
			this.options.callback($(navNode));
		}
	},
	autoScrollNextPanel: function autoScrollNextPanel() {
		var _self = this,
		    $nextTab;

		if (_self.currentTabIndex < _self.tabCount) {
			$nextTab = _self.$tabsNav.children().eq(_self.currentTabIndex);
			_self.currentTabIndex++;
		} else {
			_self.currentTabIndex = 1;
			$nextTab = _self.$tabsNav.children().first();
		}

		var button = $nextTab.find('a:first')[0];
		_self.showNextPanel(button, true);
	},
	clearIntervalOption: function clearIntervalOption() {

		if (this.timeoutID) {
			window.clearInterval(this.timeoutID);

			this.timeoutID = null;
		}
	},
	init: function init($tabs, options) {
		var defaultOptions = {
			autoScroll: false,
			callback: undefined,
			navDirection: 'horizontal',

			transitionTiming: 700,
			transitionOutClass: 'is-transitioning-out',
			transitionInClass: 'is-transitioning-in',

			beltWrapperClass: 'js-belt',
			panelClass: 'js-panel',
			panelActiveClass: 'is-panel-shown',
			pauseTransitionClass: 'transition-paused',
			contentClasses: '',

			navClass: 'global-perspectives-nav',
			navBtnClass: 'js-nav-btn',
			tabActiveClass: 'is-active-tab'
		};

		this.options = $.extend(defaultOptions, options || {});
		this.isAnimating = false;
		this.activePanelID = null;
		this.$tabs = !!$tabs ? $tabs : $('.dynamicTabs');
		this.$tabsNav = this.$tabs.find('.' + this.options.navClass);
		this.$tabButtons = this.$tabs.find('.' + this.options.navBtnClass);
		this.$panels = this.$tabs.find('[role="tabpanel"]');
		this.tabCount = this.$tabsNav.children().length;
		// Only used in when auto-play (autoScroll) is on
		this.currentTabIndex = parseInt(this.$tabsNav.data('initial-active-tab')) || 1;

		// Set up events
		var _self = this;
		this.$tabsNav.on('click mousedown', '.' + this.options.navBtnClass, function (e) {
			e.preventDefault();
			_self.clearIntervalOption();
			var clickedBtn = this;
			if ($(clickedBtn).parent().hasClass(_self.options.tabActiveClass) || _self.isAnimating) {
				return;
			}
			_self.showNextPanel(clickedBtn);
		});
		this.$tabsNav.on('keydown', '.' + this.options.navBtnClass, function (e) {
			if (_self.options.navDirection === 'horizontal') {
				if (e.keyCode === keys.left || e.keyCode === keys.right) {
					e.preventDefault();
					_self.clearIntervalOption();
					if (_self.isAnimating) {
						return;
					}
					var direction = directions[e.keyCode];
					var nextTab = _self.$tabButtons.eq(_self.$tabButtons.index(this) + direction)[0];
					if (nextTab) {
						_self.showNextPanel(nextTab);
					}
				}
			} else /* if (this.options.navDirection === 'vertical') */{
					if (e.keyCode === keys.up || e.keyCode === keys.down) {
						e.preventDefault();
						e.stopPropagation(); // Prevent scroll
						_self.clearIntervalOption();
						if (_self.isAnimating) {
							return;
						}
						var direction = directions[e.keyCode];
						var nextTab = _self.$tabButtons.eq(_self.$tabButtons.index(this) + direction)[0];
						if (nextTab) {
							_self.showNextPanel(nextTab);
						}
					}
				}
		});
		this.$tabsNav.on('mouseover focusin', '.' + this.options.navBtnClass, this.clearIntervalOption);
		this.$tabs.on('mouseover focusin', this.options.contentClasses, this.clearIntervalOption);

		// Set up auto-scroll timer (if necessary)
		this.autoscrollTimer = parseInt(this.$tabsNav.data('autoscroll-timer'));
		if (this.autoscrollTimer == 0 || this.autoscrollTimer == undefined) {
			this.options.autoScroll = false;
		}
		if (this.options.autoScroll) {
			_self.timeoutID = window.setInterval(function () {
				if (!_self.$tabsNav.hasClass(_self.options.pauseTransitionClass)) {
					_self.autoScrollNextPanel();
				}
			}, this.autoscrollTimer * 1000);
		}

		// Set initial accessibility attrs
		this.$panels.attr({ 'aria-hidden': true, 'tabindex': '-1' }).find('a, button').attr('tabindex', -1);
		this.$panels.eq(_self.currentTabIndex - 1).attr({ 'aria-hidden': false, 'tabindex': '0' }).find('a, button').attr('tabindex', 0);
		this.$tabButtons.attr('tabindex', -1);
		this.$tabs.find('.is-selected').children().attr({ 'aria-selected': true, 'tabindex': 0 });
	}
};

module.exports = dynamicTabs;

},{"./variables":67}],35:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var experiences = document.getElementById('experience-landing'),


  //modules
  pageOptions,
      searchLandingFilters,
      selectDropdowns;

  if (!experiences) {
    return;
  }

  pageOptions = {
    pageName: 'experiences-landing',
    searchPromoPanelID: 'search-entity-landing-promo',
    searchResultsID: 'search-entity-landing-results',
    alphaSearch: false
  };

  //attach helpers to window, and allow acccess  animation interactivity within custom framework(ex. angularJS,knockout.js)
  window.animationSearchHelpers = require('./animation-search-helpers');
  window.animationSearchHelpers.init(pageOptions);

  //BackEnd Developers can overwrite floowing Search landing filters, only for template specific behavior
  searchLandingFilters = require('./search-landing-filters');

  searchLandingFilters.init(pageOptions);

  //initiate selectdropdowns
  selectDropdowns = require('./select-dropdown');

  var $dropdowns = $(experiences).find('.js-select-dropdown');

  selectDropdowns($dropdowns, function selectDropdownCallback($selectEl, $selectedItem) {

    if (!!$selectedItem) {
      window.animationSearchHelpers.applySelectedFilter($selectedItem.text());
    }
  });

  //back to gc
  $dropdowns = null;

  //include large polygon;
  require('./angled-polygon');

  //return for garbage collection
  experiences = null;
}();

},{"./angled-polygon":22,"./animation-search-helpers":23,"./search-landing-filters":58,"./select-dropdown":59}],36:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var generalContent = document.getElementById('general-content'),


  //modules
  ReadMore,
      impactfulCTA,
      Accordion,
      sideNav;

  if (!generalContent) {
    if (document.getElementById('ss-embed-frame')) {
      $('#ss-embed-frame').attr('onload', 'window.scrollTo(0, 500)');
    }
    return;
  }

  //initialize overview
  ReadMore = require('./read-more');

  var readMoreNodes = $(generalContent).find('.js-read-more');

  if (readMoreNodes.length) {
    $.each(readMoreNodes, function (index, item) {
      new ReadMore($(item));
    });
  }

  Accordion = require('./accordion');

  var $accordions = $(generalContent).find('.js-accordion');

  if ($accordions.length) {

    $accordions.each(function (index, el) {
      new Accordion($(el));
    });
  }

  sideNav = require('./sidenav');

  sideNav.init();

  impactfulCTA = require('./impactful-cta');

  $(function () {
    impactfulCTA.init();
  });

  //return for garbage collection
  generalContent = readMoreNodes = null;
}();

},{"./accordion":21,"./impactful-cta":42,"./read-more":54,"./sidenav":60}],37:[function(require,module,exports){
'use strict';

var globalPerspectives,


//module imports
dynamicTabs = require('./dynamic-tabs'),
    perspectivesMenu;

globalPerspectives = {
    dynamicTabsLogic: null,
    mobileMenuInit: function mobileMenuInit() {
        var ToggleMenu = require('./toggle-menu');

        perspectivesMenu = new ToggleMenu($('.js-global-perspectives').find('.js-menu'), {
            triggerClass: 'js-nav-toggle',
            expandableMenu: 'js-menu',
            showOptions: 'show-regions-menu',
            navOptionsClass: 'js-nav-btn',
            selectedOptionClass: 'is-selected'
        });
    },
    clearIntervalOption: function clearIntervalOption() {

        this.dynamicTabsLogic.clearIntervalOption();
    },
    init: function init() {

        if ($('.js-global-perspectives').length === 0) {
            return;
        }

        this.mobileMenuInit();

        this.dynamicTabsLogic = Object.create(dynamicTabs);

        this.dynamicTabsLogic.init($('.js-global-perspectives'), {
            transitionTiming: 350,
            panelActiveClass: 'is-region-shown',
            contentClasses: '.global-perspective-region-title, .global-perspective-content-container',
            tabActiveClass: 'is-selected',
            autoScroll: true,
            callback: perspectivesMenu.updateMobileLabel.bind(perspectivesMenu)
        });
    }
};

module.exports = globalPerspectives;

},{"./dynamic-tabs":34,"./toggle-menu":64}],38:[function(require,module,exports){
"use strict";

var GlobalSolutionsProducts = function GlobalSolutionsProducts() {

    // Production steps of ECMA-262, Edition 6, 22.1.2.1
    if (!Array.from) {
        Array.from = function () {
            var toStr = Object.prototype.toString;
            var isCallable = function isCallable(fn) {
                return typeof fn === "function" || toStr.call(fn) === "[object Function]";
            };
            var toInteger = function toInteger(value) {
                var number = Number(value);
                if (isNaN(number)) {
                    return 0;
                }
                if (number === 0 || !isFinite(number)) {
                    return number;
                }
                return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
            };
            var maxSafeInteger = Math.pow(2, 53) - 1;
            var toLength = function toLength(value) {
                var len = toInteger(value);
                return Math.min(Math.max(len, 0), maxSafeInteger);
            };

            // The length property of the from method is 1.
            return function from(arrayLike /*, mapFn, thisArg */) {
                // 1. Let C be the this value.
                var C = this;

                // 2. Let items be ToObject(arrayLike).
                var items = Object(arrayLike);

                // 3. ReturnIfAbrupt(items).
                if (arrayLike == null) {
                    throw new TypeError("Array.from requires an array-like object - not null or undefined");
                }

                // 4. If mapfn is undefined, then let mapping be false.
                var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                var T;
                if (typeof mapFn !== "undefined") {
                    // 5. else
                    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                    if (!isCallable(mapFn)) {
                        throw new TypeError("Array.from: when provided, the second argument must be a function");
                    }

                    // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    if (arguments.length > 2) {
                        T = arguments[2];
                    }
                }

                // 10. Let lenValue be Get(items, "length").
                // 11. Let len be ToLength(lenValue).
                var len = toLength(items.length);

                // 13. If IsConstructor(C) is true, then
                // 13. a. Let A be the result of calling the [[Construct]] internal method
                // of C with an argument list containing the single item len.
                // 14. a. Else, Let A be ArrayCreate(len).
                var A = isCallable(C) ? Object(new C(len)) : new Array(len);

                // 16. Let k be 0.
                var k = 0;
                // 17. Repeat, while k < len… (also steps a - h)
                var kValue;
                while (k < len) {
                    kValue = items[k];
                    if (mapFn) {
                        A[k] = typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                    } else {
                        A[k] = kValue;
                    }
                    k += 1;
                }
                // 18. Let putStatus be Put(A, "length", len, true).
                A.length = len;
                // 20. Return A.
                return A;
            };
        }();
    }

    (function (w) {

        w.URLSearchParams = w.URLSearchParams || function (searchString) {
            var self = this;
            self.searchString = searchString;
            self.get = function (name) {
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
                if (results == null) {
                    return null;
                } else {
                    return decodeURI(results[1]) || 0;
                }
            };
        };
    })(window);

    // define DOM elements
    var $el = $('#products');
    var $dropdownList = $el.find('.products-dropdown__items');
    var $dropdownItem = $el.find('.products-dropdown__item');
    var dropdownArray = Array.from($dropdownList[0].children);
    var $dropdownButton = $el.find('#dropdown-button');
    var $sections = $el.find('.products__content');
    var $section = $el.find('.products__section');

    // bind events
    $dropdownButton.on('click', toggleDropdown);
    $dropdownItem.on('click', function () {
        toggleDropdown();
        activateSection(this, undefined, true);
    });

    function init() {
        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get('group')) {
            dropdownArray.map(function (item) {
                var accordionId = searchParams.get('product') ? searchParams.get('product') : '';
                if ($(item).data('group-id') == searchParams.get('group')) {
                    return activateSection(item, accordionId, true);
                }
            });
        } else {
            activateSection(dropdownArray[0]);
        }
    }
    function toggleDropdown() {
        $dropdownList.toggleClass('products-dropdown__items--active');
    }
    function activateSection(section, accordionId, scrollTo) {
        console.log(section);
        var id = $(section).data('group-id');
        var name = $(section).text();
        var activeSection = $sections.find("[data-group-id='" + id + "']");
        $dropdownButton.text(name);
        // if (id !== 'all'){ 
        $section.css('display', 'none');
        activeSection.css('display', 'block');
        searchForAccordion(activeSection, accordionId, scrollTo);
        // }
        // else {
        //     $section.css('display', 'block')
        //     activeSection.css('display', 'none')
        //     if (scrollTo)
        //         goToSection($section)
        // }
    }
    function searchForAccordion(section, id, scrollTo) {
        var activeAccordion;
        Array.from($(section).children()).map(function (item) {
            if ($(item).data('product-id') == id) {
                $(item).find('.js-accordion-trigger').trigger('click');
                activeAccordion = item;
            }
        });
        if (activeAccordion) {
            goToSection(activeAccordion);
        } else if (scrollTo) {
            goToSection(section);
        }
    }
    function goToSection(el) {
        $('html,body').animate({
            scrollTop: $(el).offset().top - 150
        }, 500);
    }

    init();
};

module.exports = GlobalSolutionsProducts;

},{}],39:[function(require,module,exports){
"use strict";

module.exports = function () {
  "use strict";

  var globalSolutions = document.getElementById("global-solutions"),
      ReadMore,
      Accordion,
      Scrollspy,
      GlobalSolutionsProducts;

  if (!globalSolutions) {
    return;
  }

  // Initialize overview
  ReadMore = require("./read-more");
  var readMoreNode = $(globalSolutions).find(".js-read-more");

  if (readMoreNode.length) {
    new ReadMore(readMoreNode);
  }

  // Initialize scrollspy
  Scrollspy = require("./scrollspy");
  Scrollspy.init();

  // initialize accordion if it exists
  var $globalAccordion = $(globalSolutions).find(".js-accordion");
  if ($globalAccordion.length) {
    Accordion = require("./accordion");
    new Accordion($globalAccordion);
  }

  var $product = $(globalSolutions).find('.products');
  if ($product.length) {
    GlobalSolutionsProducts = require('./global-solutions-products');
    GlobalSolutionsProducts();
    // new GlobalSolutionsProducts($product)
    // console.log(GlobalSolutionsProducts)
  }
}();

},{"./accordion":21,"./global-solutions-products":38,"./read-more":54,"./scrollspy":57}],40:[function(require,module,exports){
'use strict';

var $heroIntro,
    $scrollBtn,
    animationClass = 'animate-in',
    VideoPlayer,

//Module Exports
globalVars,
    heroIntro,
    VideoPlayer;

heroIntro = {

	initScrollToggle: function initScrollToggle() {
		$scrollBtn.on('click', function (e) {
			$('body,html').animate({
				scrollTop: $('.js-hero-intro').next().offset().top - globalVars.elementStates.headerHeight
			}, 600);

			$('.js-hero-intro').next().attr('tabindex', '-1');
			$('.js-hero-intro').next().focus();
		});

		$('.js-hero-intro').next().attr('tabindex', '-1');
		$('.js-hero-intro').next().focus();
	},
	init: function init($wrapper) {

		//initialize Variables
		$heroIntro = !!$wrapper ? $wrapper : $('.js-hero-intro');

		$scrollBtn = $heroIntro.find('.js-scroll-to');

		//setup classes for is in view header
		$heroIntro.find('.js-message').addClass(animationClass);

		//put max length
		var maxLengthComponent = $('[js-max-length]');
		if (maxLengthComponent.length > 0) {
			var maxLength = parseInt(maxLengthComponent.attr('js-max-length'));
			if (maxLengthComponent.text().length > maxLength) maxLengthComponent.text(maxLengthComponent.text().substring(0, maxLength).trim() + "...");
		}

		this.initScrollToggle();

		globalVars = require('./variables');

		$heroIntro = null;
	}
};

module.exports = heroIntro;

},{"./variables":67}],41:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var homepage = document.getElementById('homepage'),


  //modules
  SectionNav,
      BuildVideoPlayer,
      newsletterCarousel,
      heroIntro;

  if (!homepage) {
    return;
  }

  heroIntro = require('./hero-intro');

  heroIntro.init();

  window.globalPerspectives = require('./global-perspectives');

  window.globalPerspectives.init();

  newsletterCarousel = require('./newsletter-carousel');

  newsletterCarousel.init();

  //setup video events
  var $youtubeVideos = $('.js-youtube-video');
  if ($youtubeVideos.length) {
    BuildVideoPlayer = require('./build-video-player');

    var pageOptions = {
      animatedSections: [$('.js-global-perspectives')],
      pauseTransitionClass: 'transition-paused'
    };

    BuildVideoPlayer($youtubeVideos, pageOptions);
  }

  //return for garbage collection
  homepage = null;
}();

},{"./build-video-player":26,"./global-perspectives":37,"./hero-intro":40,"./newsletter-carousel":49}],42:[function(require,module,exports){
'use strict';

var impactfulCTA = function () {
    'use strict';

    //Is In View Header

    var $impactfulCTA, initModule, setupHoverFeature, globalVars;

    //initialize credentials accordion if it exists

    setupHoverFeature = function setupHoverFeature() {
        $impactfulCTA.on('mouseenter mouseleave', '.js-hover-trigger', function (event) {

            if (globalVars.isIpad || globalVars.isIphone) return;

            switch (event.type) {
                case 'mouseenter':

                    $impactfulCTA.addClass('is-hovered');

                    break;
                case 'mouseleave':

                    $impactfulCTA.removeClass('is-hovered');

                    break;
            }
        });
    };

    initModule = function initModule() {
        //initialize Variables
        $impactfulCTA = $('.js-impactful-cta');

        if (!$impactfulCTA.length && !$impactfulCTA.find('.js-hover-trigger').length) {
            return;
        }
        //setup classes for is in view header
        globalVars = require('./variables');

        if ($impactfulCTA.length) {
            setupHoverFeature();
        } else {
            return;
        }
    };

    return {
        init: initModule
    };
}();

module.exports = impactfulCTA;

},{"./variables":67}],43:[function(require,module,exports){
'use strict';

var lazyLoad;

lazyLoad = function () {
    'use strict';

    var lazyLoadImages, lazyLoadBackgroundImages, initializeLazyLoad;

    lazyLoadImages = function lazyLoadImages($images) {
        if ($images.length) {

            $images.each(function (index, el) {
                var $el = $(el);

                $el.attr('src', $el.data('lazy-img')).attr('data-lazy-img', '');
            });
        }

        $images = null;
    };

    lazyLoadBackgroundImages = function lazyLoadBackgroundImages($images) {

        if ($images.length) {

            $images.each(function (index, el) {
                var $el = $(el);

                $el.attr('src', $el.data('lazy-img'));

                $el.css('background-image', 'url(' + $el.data('lazy-background-img') + ')').attr('lazy-background-img', '');
            });
        }

        $images = null;
    };

    initializeLazyLoad = function initializeLazyLoad() {

        lazyLoadImages($('[data-lazy-img]'));

        lazyLoadBackgroundImages($('[data-lazy-background-img]'));
    };

    return {
        init: initializeLazyLoad
    };
}();

module.exports = lazyLoad;

},{}],44:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var locationDetail = document.getElementById('location-detail'),


  //modules
  ReadMore,
      pageOptions,
      locationMap,
      impactfulCTA,
      scrollspy;

  if (!locationDetail) {
    return;
  }
  pageOptions = {
    pageName: 'location-detail',
    searchPromoPanelID: 'search-entity-landing-promo',
    alphaSearch: false
  };

  //initialize overview
  ReadMore = require('./read-more');

  var readMoreNode = $(locationDetail).find('.js-read-more');

  if (readMoreNode.length) {
    new ReadMore(readMoreNode);
  }

  var office = window.serializedOffice;
  locationMap = require('./location-map');

  var mapNode = $(locationDetail).find('.js-location-header');
  if (mapNode.length) {
    pageOptions.locationMap = new locationMap(mapNode, office);
  }

  //vertical corner - horizontal scroller
  require('./vertical-corner').init();

  //scrollspy initialization
  scrollspy = require('./scrollspy');

  scrollspy.init();

  require('./scroll-on-load');

  impactfulCTA = require('./impactful-cta');

  $(function () {
    impactfulCTA.init();
  });

  //return for garbage collection
  locationDetail = readMoreNode = null;
}();

},{"./impactful-cta":42,"./location-map":46,"./read-more":54,"./scroll-on-load":56,"./scrollspy":57,"./vertical-corner":68}],45:[function(require,module,exports){
'use strict';

var util = require('./location-utilities');

var LocationFilters, pageOptions, searchFiltersForm, $keywordSearch, $currentLocation, $clearAll;

LocationFilters = {
    init: function init(pageConfig) {
        if (!pageConfig) {
            console.log('invalid argument, need Object supplied');
        }

        var _self = this;

        pageOptions = pageConfig;
        pageOptions.searchFormID = pageOptions.searchFormID || 'search-landing-filters';

        searchFiltersForm = document.getElementById(pageOptions.searchFormID);
        $keywordSearch = $(searchFiltersForm).find('.js-keyword-search').find('input');
        $currentLocation = $(searchFiltersForm).find('.js-current-location-search');
        $clearAll = $('.js-clear-map');

        _self.setupHandlers();
    },

    setupHandlers: function setupHandlers() {
        var _self = this;

        $keywordSearch.keypress(function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                _self.handleFindNearestOfficeSearch();
            }
        });

        $currentLocation.click(function (e) {
            e.preventDefault();
            _self.handleFindNearestOfficeCurrentLocationClick();
        });

        $(searchFiltersForm).submit(function (e) {
            e.preventDefault();
            _self.handleFindNearestOfficeSearch();
        });

        $clearAll.click(function (e) {
            e.preventDefault();
            _self.resetMap();
        });
    },

    handleFindNearestOfficeSearch: function handleFindNearestOfficeSearch() {
        var _self = this;
        var searchQuery = $keywordSearch.val();

        if (searchQuery) {
            util.geocode(searchQuery, function (currentLocation) {
                var offices = pageOptions.locationMap.offices;
                util.getNearestOffice(currentLocation, offices, function (closestOffice) {
                    _self.populateSearchWithCurrentLocation(currentLocation);
                    pageOptions.locationMap.showOffice(closestOffice);
                });
            });
        } else {
            _self.handleFindNearestOfficeCurrentLocationClick();
        }
    },

    handleFindNearestOfficeCurrentLocationClick: function handleFindNearestOfficeCurrentLocationClick() {
        var _self = this;
        util.getCurrentLocation(function (currentLocation) {
            var offices = pageOptions.locationMap.offices;
            util.getNearestOffice(currentLocation, offices, pageOptions.locationMap.showOffice.bind(pageOptions.locationMap));
        });
    },

    populateSearchWithCurrentLocation: function populateSearchWithCurrentLocation(currentLocation) {
        util.geocode(currentLocation, function (address) {
            $('#keywordSearch').val(address);
        });
    },

    resetMap: function resetMap() {
        var mapModule = pageOptions.locationMap;

        mapModule.$Map.width('100%');
        mapModule.$LocationMap.removeClass('show-image');
        google.maps.event.trigger(window.map, 'resize');
        $keywordSearch.focus();
        window.map.setCenter({ lat: 20, lng: 0 });
        window.map.setZoom(2);
    }
};

module.exports = LocationFilters;

},{"./location-utilities":47}],46:[function(require,module,exports){
'use strict';

var util = require('./location-utilities');

function LocationMap($node, office) {
    this.$LocationMap = $node;
    this.$Map = $node.find('.map');
    this.$locationImage = $node.find('.location-image');
    this.$officeName = this.$locationImage.find('.city-name');
    this.$address1 = this.$locationImage.find('.address-one');
    this.$address2 = this.$locationImage.find('.address-two');
    this.$address3 = this.$locationImage.find('.address-three');
    this.$address4 = this.$locationImage.find('.address-four');
    this.$phone = this.$locationImage.find('.phone');
    this.$fax = this.$locationImage.find('.fax');
    this.$searchInput = $node.find('.keyword-search-input');
    this.$getDirectionsButton = $node.find('.get-directions');
    this.$currentLocationButton = $node.find('.location-searchbox-nearest-office');

    this.selectedOffice;
    if (office) {
        this.selectedOffice = office;
        this.init(office);
    } else {
        this.offices = window.serializedOffices;
        this.init();
    }
}

function populateSearchWithCurrentLocation(currentLocation) {
    reverseGeocode(currentLocation, function (address) {
        $('.location-searchbox-input').val(address);
    });
};

LocationMap.prototype.init = function (office) {
    var _self = this;

    $(window).on('googleMapsLoaded', function () {
        var markerImage = {
            url: '/assets/site/public/images/map-marker.png'
        };
        var markers = [],
            infoWindows = [];

        if (!office) {
            for (var i = 0; i < _self.offices.length; i++) {
                var currentOffice = _self.offices[i];

                var marker = new google.maps.Marker({
                    map: window.map,
                    position: currentOffice.latLng,
                    icon: markerImage
                });

                markers.push(marker);

                var content = '<div class="marker-info-window"><a href="{0}">{1}</a></div>'.format(currentOffice.url, currentOffice.name);
                var infoWindow = new google.maps.InfoWindow();

                infoWindows.push(infoWindow);

                google.maps.event.addListener(marker, 'click', function (marker, content, infoWindow) {
                    return function () {
                        infoWindow.setContent(content);
                        infoWindow.open(map, marker);
                    };
                }(marker, content, infoWindow));
            }

            google.maps.event.addListener(map, 'click', function (event) {
                for (var i = 0; i < infoWindows.length; i++) {
                    infoWindows[i].close();
                }
            });
        } else {
            var marker = new google.maps.Marker({
                map: window.map,
                position: office.latLng,
                icon: markerImage
            });

            _self.showOffice(office);
            _self.bindEvents();
        }
    });
};

LocationMap.prototype.bindEvents = function bindEvents() {
    var _self = this;

    this.$getDirectionsButton.click(function () {
        _self.handleSearchForDirections();
    });

    _self.$currentLocationButton.click(function () {
        _self.handleUseCurrentLocationClick();
    });
};

LocationMap.prototype.handleSearchForDirections = function () {
    var _self = this;
    var input = _self.$searchInput.val();

    if (input) {
        util.geocode(input, function (origin) {
            var destination = _self.selectedOffice.latLng;
            util.getDirections(origin, destination);
        });
    } else {
        _self.handleUseCurrentLocationClick();
    }
};

LocationMap.prototype.handleUseCurrentLocationClick = function () {
    var _self = this;
    util.getCurrentLocation(function (currentLocation) {
        var destination = _self.selectedOffice.latLng;
        util.getDirections(currentLocation, destination, populateSearchWithCurrentLocation);
    });
};

LocationMap.prototype.showOffice = function (office) {
    if (!office) return;

    this.$Map.width($('#locations-landing').length ? '50%' : '100%');

    this.$LocationMap.addClass('show-image');
    google.maps.event.trigger(window.map, 'resize');

    window.map.setCenter(office.latLng);
    window.map.setZoom(12);

    this.$locationImage.css('background-image', 'url(' + office.img + ')');
    this.$officeName.text(office.name);
    this.$officeName.attr('href', office.url);

    this.$address1.text(office.address);
    var formattedLocation = office.city + ', ' + office.state + ' ' + office.zip;
    this.$address2.text(formattedLocation);
    this.$address3.text(office.country);

    if (office.phone) {
        this.$phone.text(office.phone);
        this.$phone.attr('href', 'tel:' + office.phone);
    } else {
        this.$phone.hide();
    }

    if (office.fax) {
        this.$fax.text(office.fax);
    } else {
        this.$fax.hide();
    }
};

module.exports = LocationMap;

},{"./location-utilities":47}],47:[function(require,module,exports){
'use strict';

module.exports = {
    getCurrentLocation: function getCurrentLocation(callback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var currentLocation = { lat: position.coords.latitude, lng: position.coords.longitude };
                callback(currentLocation);
            });
        }
    },

    getDirections: function getDirections(origin, destination, callback) {
        var url = 'https://www.google.com/maps/dir/{0}/{1}/'.format(origin.lat + ',' + origin.lng, destination.lat + ',' + destination.lng);
        window.open(url, 'google_directions', 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
        if (callback) callback(origin);
    },

    geocode: function geocode(address, callback) {
        if (geocoder) {
            geocoder.geocode({ 'address': address }, function (results, status) {
                if (status == 'OK' && results[0]) {
                    var location = results[0].geometry.location;
                    var resolvedCoords = { lat: location.lat(), lng: location.lng() };
                    callback(resolvedCoords);
                }
            });
        }
    },

    reverseGeocode: function reverseGeocode(latLng, callback) {
        if (geocoder) {
            geocoder.geocode({ 'location': latLng }, function (results, status) {
                if (status == 'OK' && results[0]) {
                    var resolvedLocation = results[0];
                    callback(resolvedLocation.formatted_address);
                }
            });
        }
    },

    getNearestOffice: function getNearestOffice(currentLocation, offices, callback) {
        var _self = this;
        var mindif = 99999,
            closest;

        if (currentLocation) {
            for (var i = 0; i < offices.length; i++) {
                var dif = _self.PythagorasEquirectangular(currentLocation.lat, currentLocation.lng, offices[i].latLng.lat, offices[i].latLng.lng);
                if (dif < mindif) {
                    closest = i;
                    mindif = dif;
                }
            }

            if (closest || closest === 0) {
                var closestOffice = offices[closest];
                callback(closestOffice);
            }
        }
    },

    PythagorasEquirectangular: function PythagorasEquirectangular(lat1, lon1, lat2, lon2) {
        var _self = this;

        lat1 = _self.Deg2Rad(lat1);
        lat2 = _self.Deg2Rad(lat2);
        lon1 = _self.Deg2Rad(lon1);
        lon2 = _self.Deg2Rad(lon2);
        var R = 6371; // km
        var x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
        var y = lat2 - lat1;
        var d = Math.sqrt(x * x + y * y) * R;
        return d;
    },

    Deg2Rad: function Deg2Rad(deg) {
        return deg * Math.PI / 180;
    }
};

},{}],48:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var locations = document.getElementById('locations-landing'),


  //modules
  pageOptions,
      LocationLandingFilters,
      locationMap,
      impactfulCTA,
      selectDropdowns;

  if (!locations) {
    return;
  }

  pageOptions = {
    pageName: 'locations-landing',
    searchPromoPanelID: 'search-entity-landing-promo',
    alphaSearch: false
  };

  //attach helpers to window, and allow acccess  animation interactivity within custom framework(ex. angularJS,knockout.js)

  locationMap = require('./location-map');
  var mapNode = $(locations).find('.location-map');
  if (mapNode.length) {
    pageOptions.locationMap = new locationMap(mapNode);
  }
  //BackEnd Developers can overwrite floowing Search landing filters, only for template specific behavior
  LocationLandingFilters = require('./location-landing-filters');

  LocationLandingFilters.init(pageOptions);

  impactfulCTA = require('./impactful-cta');

  $(function () {
    impactfulCTA.init();
  });

  //return for garbage collection
  locations = null;
}();

},{"./impactful-cta":42,"./location-landing-filters":45,"./location-map":46}],49:[function(require,module,exports){
'use strict';

var newsletterCarousel,


//module imports
dynamicTabs = require('./dynamic-tabs');

newsletterCarousel = {

	init: function init() {

		if ($('.js-newsletter-carousel').length === 0) {
			return;
		}

		this.tabLogic = Object.create(dynamicTabs);

		this.tabLogic.init($('.js-newsletter-carousel'), {
			transitionTiming: 350,
			beltWrapperClass: 'js-newsletter-slides',
			panelActiveClass: 'is-issue-shown',
			navClass: 'newsletter-carousel-nav',
			navDirection: 'vertical',
			navBtnClass: 'newsletter-carousel-btn',
			tabActiveClass: 'is-selected'
		});
	}
};

module.exports = newsletterCarousel;

},{"./dynamic-tabs":34}],50:[function(require,module,exports){
"use strict";

module.exports = function () {
  "use strict";

  var perspectivesDetail = document.getElementById("perspectives-detail"),
      ReadMore,
      Scrollspy;

  if (!perspectivesDetail) {
    return;
  }

  // Initialize overview
  ReadMore = require("./read-more");
  var readMoreNode = $(perspectivesDetail).find(".js-read-more");

  if (readMoreNode.length) {
    new ReadMore(readMoreNode);
  }

  window.stickyShare = require('./sticky-share');

  window.stickyShare.init();

  // Initialize scrollspy
  Scrollspy = require("./scrollspy");
  Scrollspy.init();

  require("./reader-progress").init();

  perspectivesDetail = null;
}();

},{"./read-more":54,"./reader-progress":55,"./scrollspy":57,"./sticky-share":63}],51:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var professionalDetail = document.getElementById('professional-detail'),


  //modules
  ReadMore,
      Accordion,
      scrollspy,
      capabilitiesCompact;

  if (!professionalDetail) {
    return;
  }

  //initialize overview
  ReadMore = require('./read-more');

  var readMoreNodes = $(professionalDetail).find('.js-read-more');

  if (readMoreNodes.length) {
    $.each(readMoreNodes, function (index, item) {
      new ReadMore($(item));
    });
  }

  //initialize credentials accordion if it exists
  Accordion = require('./accordion');

  var $credentialsAccordion = $(professionalDetail).find('.js-accordion');

  if ($credentialsAccordion.length) {
    new Accordion($credentialsAccordion);
  }

  //scrollspy initialization
  scrollspy = require('./scrollspy');
  scrollspy.init();

  // Ensure Flex Area menu option populated
  var flexAreaLink = document.querySelector("a[href='#flex-area']");
  var $label = $(flexAreaLink).find('.scrollspy-nav-label');

  if ($label.length) {
    var lawyerHeader = document.getElementsByClassName('lawyerHeader')[0];
    var sectionHeader = document.getElementsByClassName('flex-area-title')[0];

    var labelText = "";

    if (sectionHeader) {
      labelText = sectionHeader.textContent;
    }

    if (!!lawyerHeader) {
      if (labelText == "") {
        labelText = lawyerHeader.textContent;
      }
      $label.text(labelText);
      $label.attr('title', 'Jump to ' + lawyerHeader.textContent + ' Section');
      $(flexAreaLink).attr('title', 'Jump to ' + lawyerHeader.textContent + ' Section');
    }
  }

  capabilitiesCompact = require('./capabilities-compact');
  capabilitiesCompact.init();

  if ($('main#professional-detail')) {
    window.addEventListener('keydown', function (event) {
      if (!window.getQueryString('p') && (event.ctrlKey || event.metaKey) && String.fromCharCode(event.which).toLowerCase() == 'p') {
        event.preventDefault();
        window.reloadWithQueryStringVars({ 'print': 1 });
      }
    });
  }

  require('./scroll-on-load');

  //return for garbage collection
  professionalDetail = readMoreNodes = null;
}();

},{"./accordion":21,"./capabilities-compact":27,"./read-more":54,"./scroll-on-load":56,"./scrollspy":57}],52:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var professionals = document.getElementById('professionals-landing'),


  //modules
  pageOptions,
      searchLandingFilters,
      selectDropdowns;

  if (!professionals) {
    return;
  }

  pageOptions = {
    pageName: 'professionals-landing',
    searchPromoPanelID: 'search-entity-landing-promo',
    searchResultsID: 'search-entity-landing-results',
    alphaSearch: true
  };

  //attach helpers to window, and allow acccess  animation interactivity within custom framework(ex. angularJS,knockout.js)
  window.animationSearchHelpers = require('./animation-search-helpers');
  window.animationSearchHelpers.init(pageOptions);

  //BackEnd Developers can overwrite floowing Search landing filters, only for template specific behavior
  searchLandingFilters = require('./search-landing-filters');
  searchLandingFilters.init(pageOptions);

  //initiate selectdropdowns
  selectDropdowns = require('./select-dropdown');

  var $dropdowns = $(professionals).find('.js-select-dropdown');

  selectDropdowns($dropdowns, function selectDropdownCallback($selectEl, $selectedItem) {

    if (!!$selectedItem) {
      window.animationSearchHelpers.applySelectedFilter($selectedItem.text());
    }
  });

  window.BuildVideoPlayer = require('./build-video-player');

  //back to gc
  $dropdowns = null;

  //return for garbage collection
  professionals = null;
}();

},{"./animation-search-helpers":23,"./build-video-player":26,"./search-landing-filters":58,"./select-dropdown":59}],53:[function(require,module,exports){
'use strict';

module.exports = function () {
    if (!String.prototype.format) {
        String.prototype.format = function () {
            var args = arguments;
            return this.replace(/{(\d+)}/g, function (match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            });
        };
    }

    if (!Array.prototype.pushArray) {
        Array.prototype.pushArray = function () {
            var toPush = this.concat.apply([], arguments);
            for (var i = 0, len = toPush.length; i < len; ++i) {
                this.push(toPush[i]);
            }
        };
    }

    // Mozilla MDN Polyfill: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find#Polyfill
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, "find", {
            value: function value(predicate) {
                if (this === null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;

                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }
                return undefined;
            }
        });
    }

    if (!Array.prototype.copy) {
        Object.defineProperty(Array.prototype, 'copy', {
            value: function value() {
                if (this === null || this === undefined) {
                    throw new TypeError('Array.prototype.copy called on null or undefined');
                }
                var array = Object(this);
                return JSON.parse(JSON.stringify(array));
            }
        });
    }

    if (!Array.prototype.remove) {
        Object.defineProperty(Array.prototype, 'remove', {
            value: function value(item) {
                if (this === null || this === undefined) {
                    throw new TypeError('Array.prototype.copy called on null or undefined');
                }
                var array = Object(this);
                var index = array.indexOf(item);
                if (index > -1) {
                    array.splice(index, 1);
                }
            }
        });
    }
}();

},{}],54:[function(require,module,exports){
'use strict';

function ReadMore($expandNode) {
    this.$ReadMore = $expandNode;
    this.$trigger = this.$ReadMore.find('.js-toggle-btn');
    this.$contentCollapsed = this.$ReadMore.find('.js-full-copy');
    this.labelCollapsed = this.$contentCollapsed.data('label-more');
    this.labelExpanded = this.$contentCollapsed.data('label-less');
    this.visibility = false;
    this.activeClass = 'is-expanded';
    this.animationSpeed = 350;
    this.scrollUpOnCollapse = false;

    this.bindEvents();
}

ReadMore.prototype.expandContent = function readMore() {
    this.visibility = true;

    this.$contentCollapsed.slideDown(this.animationSpeed, function () {
        if (window.stickyShare !== undefined) {
            window.stickyShare.update();
        }
    }).attr('aria-expanded', true).attr('aria-hidden', false).attr('tabindex', -1).focus();

    this.$trigger.addClass(this.activeClass).attr('aria-expanded', true).find('.btn-ghost-label').text(this.labelExpanded);
};

ReadMore.prototype.collapseContent = function readLess() {

    var _self = this;

    this.visibility = false;

    this.$contentCollapsed.slideUp(this.animationSpeed, function () {
        if (window.stickyShare !== undefined) {
            window.stickyShare.update();
        }
    }).attr('aria-expanded', false).attr('aria-hidden', true).attr('tabindex', -1);

    this.$trigger.removeClass(this.activeClass).attr('aria-expanded', false).find('.btn-ghost-label').text(_self.labelCollapsed);

    if (this.scrollUpOnCollapse) {
        $('body,html').animate({ scrollTop: this.$ReadMore.offset().top }, this.animationSpeed);
    }
};

ReadMore.prototype.toggleVisibility = function toggle() {
    this.visibility === true ? this.collapseContent() : this.expandContent();
};

ReadMore.prototype.bindEvents = function bindEvents() {

    var _self = this;

    this.scrollUpOnCollapse = this.$ReadMore.data('scroll-on-collapse');

    _self.$trigger.on('click.ReadMore', function (ev) {
        ev.preventDefault();

        _self.toggleVisibility();
    });
};

module.exports = ReadMore;

},{}],55:[function(require,module,exports){
'use strict';

var $readerProgress,
    $readerProgressBar,
    $progressBody,

//offsets/classes
headerOffsets,
    stickyClass = 'reader-progress--sticky',


//magic controller
magicController,
    sceneCollection,


//modules
globalVars,
    readerProgress;

readerProgress = {
  stickyMenuInit: function stickyMenuInit(headerOffsets) {
    sceneCollection['reader'] = new ScrollMagic.Scene({
      triggerElement: $readerProgress[0],
      triggerHook: 0,
      offset: headerOffsets
    }).setClassToggle($readerProgress[0], stickyClass).addTo(magicController);
  },
  magicSceneInit: function magicSceneInit() {
    sceneCollection['reader-body'] = new ScrollMagic.Scene({
      triggerElement: $progressBody[0],
      triggerHook: 1,
      duration: function duration() {
        return $progressBody.outerHeight();
      }
    }).on('progress', function (e) {
      $readerProgressBar.width(e.progress.toFixed(2) * 100 + '%');
    })
    // .addIndicators()
    .addTo(magicController);
  },
  init: function init() {
    //globalVariables
    globalVars = require('./variables');

    magicController = globalVars.magicController;
    sceneCollection = globalVars.sceneCollection;

    //initialize elements;
    $readerProgress = $('.js-reader-progress');
    $readerProgressBar = $readerProgress.find('.js-reader-progress__bar');
    $progressBody = $('.js-reader-progress-body');

    headerOffsets = (globalVars.isMobile ? globalVars.elementStates.headerHeight * -1 : 0) - 30;

    this.stickyMenuInit(headerOffsets);
    this.magicSceneInit();
  }
};

module.exports = readerProgress;

},{"./variables":67}],56:[function(require,module,exports){
'use strict';

var globalVars = require('./variables'),
    scrollToSection = window.getQueryString('section');

if (scrollToSection) {
	var counter = 0;
	var scrollChecker = setInterval(function () {
		if (counter > 10) clearInterval(scrollChecker);

		if (window.vueAppsLoaded()) {
			clearInterval(scrollChecker);

			var sectionId = '#' + scrollToSection,
			    $section = $(sectionId);

			if ($section.length) {
				var sectionOffset = $section.offset().top;
				if (globalVars.isMobile) {
					sectionOffset = sectionOffset - 70;
				}

				$('html,body').animate({
					scrollTop: sectionOffset
				}, 500);
			}
		} else {
			counter++;
		}
	}, 100);
}

},{"./variables":67}],57:[function(require,module,exports){
'use strict';

var $scrollspy,
    $menu,
    $menuItems,
    $navList,
    $navLinks,
    $scrollSections,
    $mobileToggle,
    nodeCollection,


//offsets/classes
headerOffsets,
    activeNavClass,
    mobileToggleClass,
    removeExposedNavOnce = false,


//magic controller
magicController,
    sceneCollection,


//modules
globalVars,
    windowResize,
    scrollspy;

scrollspy = {
    stickyMenuInit: function stickyMenuInit(headerOffsets) {
        sceneCollection['sticky-menu'] = new ScrollMagic.Scene({
            triggerElement: $scrollspy[0],
            triggerHook: 0,
            offset: headerOffsets,
            duration: function duration() {
                return Math.ceil($scrollspy.height()) - Math.ceil($menu.outerHeight());
            }
        }).on('enter leave', function (e) {
            e.type === 'enter' ? $menu.addClass('is-sticky') : $menu.removeClass('is-sticky');
        }).on('end', function (e) {
            e.state === 'AFTER' ? $menu.addClass('is-sticky-bottom') : $menu.removeClass('is-sticky-bottom');
        })
        //.addIndicators()
        .addTo(magicController);

        //setup initial state
        $menuItems.eq(0).addClass(activeNavClass);
    },

    scrollToSection: function scrollToSection(sectionName) {
        var $sectionModule = nodeCollection[sectionName].module,
            sectionOffset = $sectionModule.offset().top,
            finalOffset = sectionOffset + headerOffsets;

        var sectionId = $sectionModule.attr('id');
        var updatedUrl = window.updateQueryString(window.location.href, 'section', sectionId);
        window.history.pushState({ section: sectionId }, sectionId, updatedUrl);

        if (globalVars.isMobile) {
            finalOffset = finalOffset - 70;
        } //magic number is height of subnavigation;

        $('html,body').animate({ scrollTop: finalOffset }, 500, function () {
            $sectionModule[0].focus();
        });
    },

    magicSceneInit: function magicSceneInit() {
        var updateNavStatus,
            addMagicSceneSection,
            resizeMagicLogic,
            _self = this;

        //updating navigation
        updateNavStatus = function updateNavStatus(sectionName) {
            $menuItems.removeClass(activeNavClass);

            if (!!sectionName) {
                nodeCollection[sectionName].navItem.addClass(activeNavClass);
            }

            $mobileToggle.text(nodeCollection[sectionName].navItem.text());
        };

        addMagicSceneSection = function addMagicSceneSection(key) {

            var moduleName = key;

            sceneCollection[moduleName + 'scene'] = new ScrollMagic.Scene({
                triggerElement: nodeCollection[moduleName].module[0],
                duration: function duration() {
                    return nodeCollection[moduleName].module.outerHeight();
                }
            }).on('enter', function () {
                updateNavStatus(moduleName);
            })
            // .addIndicators()
            .addTo(magicController);
        };

        Object.keys(nodeCollection).forEach(function (key, index) {
            addMagicSceneSection(key);
        });

        //dont need sections anymore, have it garbage collected;
        addMagicSceneSection = null;
    },

    menuEventsInit: function menuEventsInit() {
        var _self = this;
        $menu.on('click.scrollspy', '.js-link', function (ev) {

            ev.stopPropagation();
            ev.preventDefault();

            var sectionID = this.getAttribute('href');

            sectionID = sectionID.slice(1).toLowerCase();

            _self.scrollToSection(sectionID);

            if ($menu.hasClass(mobileToggleClass)) {
                $menu.removeClass(mobileToggleClass).find('.scrollspy-nav-list').attr('aria-hidden', 'true');

                $(this).attr('aria-expanded', 'false');
            }
        });

        //mobile toggle
        $mobileToggle.on('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();

            if ($menu.hasClass(mobileToggleClass)) {
                $menu.removeClass(mobileToggleClass);
                $navList.attr('aria-hidden', true);
                $navLinks.attr('tabindex', -1);
                $mobileToggle.attr('aria-expanded', 'false');
            } else {
                $menu.addClass(mobileToggleClass);
                $navList.attr('aria-hidden', false);
                $navLinks.attr('tabindex', 0);
                $mobileToggle.attr('aria-expanded', 'true');
            }
        });
    },
    onMobileBreakpointCrossed: function onMobileBreakpointCrossed(isMobile) {
        if (isMobile) {
            // dropdown menu display
            if ($menu.hasClass(mobileToggleClass)) {
                // dropdown menu is open
                $navList.attr('aria-hidden', false);
                $navLinks.attr('tabindex', 0);
                $mobileToggle.attr('aria-expanded', 'true');
            } else {
                // dropdown menu is closed
                $navList.attr('aria-hidden', true);
                $navLinks.attr('tabindex', -1);
                $mobileToggle.attr('aria-expanded', 'false');
            }
        } else {
            // horizontal menu display (always open)
            $navList.removeAttr('aria-hidden');
            $navLinks.removeAttr('tabindex');
            $mobileToggle.attr('aria-expanded', 'true');
        }
    },
    init: function init() {

        var populateNodeCollection;

        //globalVariables
        globalVars = require('./variables');

        magicController = globalVars.magicController;
        sceneCollection = globalVars.sceneCollection;

        //initialize elements;
        $scrollspy = $('.js-scrollspy');
        $menu = $scrollspy.find('.js-scrollspy-nav');
        $menuItems = $menu.find('.js-option');
        $navList = $menu.find('.scrollspy-nav-list');
        $navLinks = $navList.find('.scrollspy-nav-link');
        $scrollSections = $scrollspy.find('.js-scrollspy-section');
        $mobileToggle = $menu.find('.js-nav-toggle');

        //variables
        activeNavClass = 'is-inview';
        mobileToggleClass = 'show-menu';
        headerOffsets = globalVars.elementStates.headerHeight * -1 - 20;

        nodeCollection = {};

        populateNodeCollection = function populateNodeCollection($sectionNode) {
            $sectionNode.attr('tabindex', -1);
            var sectionID = $sectionNode[0].getAttribute('id'),
                $navNode = $menuItems.filter(function (index) {

                var hrefAttribute = $(this).find('.js-link')[0].getAttribute('href');

                return sectionID === hrefAttribute.slice(1);
            });

            nodeCollection[sectionID] = {
                module: $sectionNode,
                navItem: $navNode
            };
        };

        for (var i = $scrollSections.length - 1; i >= 0; i--) {
            populateNodeCollection($scrollSections.eq(i));
        }

        var mqList = window.matchMedia('(max-width: 759px)');
        mqList.addListener(function (e) {
            this.onMobileBreakpointCrossed(e.matches);
        }.bind(this));
        this.onMobileBreakpointCrossed(mqList.matches);

        populateNodeCollection = $scrollSections = null;

        this.stickyMenuInit(headerOffsets);
        this.menuEventsInit();
        this.magicSceneInit();
    }
};

module.exports = scrollspy;

},{"./variables":67}],58:[function(require,module,exports){
'use strict';

var searchFiltersForm, pageOptions, $keywordSearch, $clearAll, focusableSelector, SearchLandingFilters;

SearchLandingFilters = {
    initAlphaOptions: function initAlphaOptions() {
        var _self = this;

        $(searchFiltersForm).find('.js-alpha-search').on('click', '.js-alpha-letter', function (ev) {
            ev.preventDefault();

            var $this = $(this);

            if ($this.hasClass('is-selected')) {
                $this.removeClass('is-selected');
                return;
            }

            // This code can be replaced with framework of choice
            _self.handleContentDisplay();
        });
    },

    handleContentDisplay: function handleContentDisplay() {
        var searchResultsContent = document.getElementById(pageOptions.searchResultsID);

        searchResultsContent.getAttribute('aria-hidden') === 'true' ? window.animationSearchHelpers.transitionFromDefaultToResults() : window.animationSearchHelpers.showSearchResults();

        searchResultsContent = null;
    },

    handleKeywordInputs: function handleKeywordInputs() {
        $keywordSearch.each(function (index, el) {
            if (!!$(el).val()) {
                window.animationSearchHelpers.applySelectedFilter($(el).val());
            }
        });
    },

    initClearAllEvent: function initClearAllEvent() {
        $clearAll.on('click.clearResults', function (ev) {
            ev.stopPropagation();
            window.animationSearchHelpers.transitionToSearchDefault();
        });
    },

    transitionToSearchDefault: function transitionToSearchDefault() {
        window.animationSearchHelpers.transitionToSearchDefault();
    },

    advancedSearchInit: function advancedSearchInit() {
        var $advancedFilters = $(searchFiltersForm).find('.js-advanced-filters');

        $advancedFilters.on('click', '.js-categories-trigger', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();

            $(this).toggleClass('is-expanded');
        });
    },

    initSubmitEvent: function initSubmitEvent() {
        var _self = this;

        $(searchFiltersForm).submit(function (ev) {
            ev.preventDefault();

            _self.handleContentDisplay();
            _self.handleKeywordInputs();
        });
    },

    // $('');

    setDropdownAccessibility: function setDropdownAccessibility() {
        var tablet = window.matchMedia('(max-width: 56.1875em)');
        if (tablet.matches) {
            $('.js-categories').attr('aria-hidden', true).find(focusableSelector).attr('tabindex', -1);
        } else {
            $('.js-categories').attr('aria-hidden', false).find(focusableSelector).attr('tabindex', 0);
        }
    },

    init: function init(pageConfig) {
        if (!pageConfig) {
            console.log('invalid argument, need Object supplied');
        }

        pageOptions = pageConfig;
        pageOptions.searchFormID = pageOptions.searchFormID || 'search-landing-filters';

        searchFiltersForm = document.getElementById(pageOptions.searchFormID);

        // Assign jQuery elements
        $keywordSearch = $(searchFiltersForm).find('.js-keyword-search').find('input');
        $clearAll = $('.js-applied-filters').find('.js-filter-clear');
        focusableSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

        this.initSubmitEvent();
        this.advancedSearchInit();
        this.setDropdownAccessibility();
        $(window).resize(this.setDropdownAccessibility);

        var _self = this;

        if (!!pageOptions.alphaSearch) {
            this.initAlphaOptions();
        }
    }
};

module.exports = SearchLandingFilters;

},{}],59:[function(require,module,exports){

'use strict';

var updateFacadeText, initializeDropdowns, focusOnDropdown, runCallback;

updateFacadeText = function updateFacadeText(selectLabel) {
    var $this = $(this),
        $selectedItem,
        $selectLabel,
        currentText;

    $selectedItem = $this.find(':selected');

    if (!$selectedItem.length) {
        return;
    }

    // get the facade element used to display
    // the text of the selected option
    $selectLabel = $this.siblings(selectLabel);

    // get 'value' attribute value for selected option
    currentText = $selectedItem.text();

    // update select text label with current selected option value
    if ($selectLabel.length && currentText.length) {
        $selectLabel.text(currentText);
    }
};

focusOnDropdown = function focusOnDropdown() {
    var $dropdownToggle = $(this);

    $dropdownToggle.next().focus();
};

runCallback = function runCallback(callback) {
    var $this = $(this),
        $selectedItem = $this.find(':selected');

    callback($this, $selectedItem);
};

initializeDropdowns = function initializeDropdowns($selectDropdowns, callback) {
    var $dropdowns = $selectDropdowns,
        eventNamespace = '.selectDropdown',
        eventToggleNamespace = '.toggleDropdown';

    $dropdowns.off('change' + eventNamespace).on('change' + eventNamespace, '.select-dropdown-select', function () {

        updateFacadeText.call(this, '.select-dropdown-toggle');

        if (typeof callback === 'function') {
            runCallback.call(this, callback);
        }
    });

    $dropdowns = null;
};

module.exports = initializeDropdowns;

},{}],60:[function(require,module,exports){
'use strict';

var sideNav = function () {
    'use strict';

    var $sideNav, $currentChildPage, initModule, initialized, setupDesktopLogic, setupMobileLogic, isChildPage, openParentAccordion, globalVars, ToggleMenu, Accordion;

    setupDesktopLogic = function setupDesktopLogic() {
        Accordion = require('./accordion');

        new Accordion($sideNav.find('.js-sidenav-list'));

        if (isChildPage()) {
            openParentAccordion($currentChildPage);
        }
    };

    setupMobileLogic = function setupMobileLogic() {
        ToggleMenu = require('./toggle-menu');

        new ToggleMenu($sideNav, {
            triggerClass: 'js-mobile-toggle',
            expandableMenu: 'js-sidenav-list',
            showOptions: 'show-menu'
        });
    };

    initModule = function initModule() {
        if (initialized) {
            return;
        }

        initialized = true;
        $sideNav = $('.js-sidenav');
        $currentChildPage = $(".sidenav-currently-featured-page")[0];
        globalVars = require('./variables');

        setupDesktopLogic();
        setupMobileLogic();
    };

    isChildPage = function isChildPage() {
        return typeof $currentChildPage !== 'undefined';
    };

    openParentAccordion = function openParentAccordion(element) {
        var $content = $(element).parent().hasClass('sidenav-grandchildren') ? $(element).closest('.js-accordion-content') : $(element).parent('.js-accordion-content');

        $content.siblings('.sidenav-section-header').children('.js-accordion-trigger').click();
    };

    return {
        init: initModule
    };
}();

module.exports = sideNav;

},{"./accordion":21,"./toggle-menu":64,"./variables":67}],61:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var siteSearchResults = document.getElementById('site-search-results');

  if (!siteSearchResults) {
    return;
  }

  // Include large polygon
  require('./angled-polygon');

  // Return for garbage collection
  siteSearchResults = null;
}();

},{"./angled-polygon":22}],62:[function(require,module,exports){
'use strict';

//globalVariables

var globalVars = require('./variables');
function SliderCarousel($carousel) {
    this.$Carousel = $carousel;
    this.$dotsContainer = this.$Carousel.find('.js-dots');
    this.$slides = this.$Carousel.find('.js-slides');
    this.$container = this.$Carousel.find('.js-slide-container');
    this.dotsHtml = "<span class='slider-dot js-dot'></span>";
    this.margin = 20;
    this.activeClass = 'active';
    this.animationSpeed = 350;
    this.slideIndex = 0;

    this.init();
    this.bindEvents();
}
SliderCarousel.prototype.init = function () {
    this.adjustSlides();
    this.adjustDots();
    this.moveToSlide(this.slideIndex);
};
SliderCarousel.prototype.adjustSlides = function Carousel() {
    var width = this.$Carousel.width();
    if (globalVars.isMobile) {
        //only show one slide at a time
        this.$slides.width(width);
        this.$container.width(width * this.$slides.length);
    } else {
        //two slides visible
        this.$slides.width(width / 2 - this.margin);
        this.$container.width(width * this.$slides.length / 2 + 20);
    }
};

SliderCarousel.prototype.adjustDots = function () {
    this.$dotsContainer.empty();
    var numDots = this.$slides.length;
    if (!globalVars.isMobile) {
        //only show one slide at a time
        numDots = Math.ceil(numDots / 2);
    }
    var self = this;
    for (var i = 0; i < numDots; i++) {
        var $dot = $(this.dotsHtml);
        $dot.attr('data-index', i);
        if (this.slideIndex == i) {
            $dot.addClass(this.activeClass);
        }
        this.$dotsContainer.append($dot);
    }
    this.$dots = this.$dotsContainer.find('.js-dot');
    this.$dots.click(function () {
        var $this = $(this);
        self.moveToSlide($this.data('index'));
    });
    //make sure slideIndex isn't out of bounds
    this.slideIndex = this.slideIndex > this.$dots.length ? Math.floor(this.slideIndex / 2) : this.slideIndex;
};

SliderCarousel.prototype.moveToSlide = function (slideIndex) {
    this.slideIndex = slideIndex;
    this.$container.animate({
        right: slideIndex * this.$Carousel.width()
    }, 500);
    this.$dots.removeClass(this.activeClass);
    $(this.$dots[this.slideIndex]).addClass(this.activeClass);
};

SliderCarousel.prototype.bindEvents = function () {

    var _self = this;

    globalVars.windowResize.add(function () {
        _self.init();
    });
};

module.exports = SliderCarousel;

},{"./variables":67}],63:[function(require,module,exports){
'use strict';

var stickyShare = function () {
    'use strict';

    //Is In View Header

    var $stickyMenu,
        $stickyModule,
        stickyOffset,
        anchoredBottomOffset,
        paddingTopOnceSticky = 25,
        isStickyClass = 'is-sticky',
        isAnchoredBottomClass = 'is-anchored-bottom',
        pageOffset,
        rAFTicker = false,
        globalVars,
        setupWindowOffsets,
        initPageScroll,
        initModule;

    setupWindowOffsets = function setupOffsets() {

        stickyOffset = $stickyModule.offset().top - globalVars.elementStates.headerHeight - paddingTopOnceSticky;

        anchoredBottomOffset = Math.ceil($stickyModule.height()) - Math.ceil($stickyMenu.height()) + stickyOffset;
    };

    initPageScroll = function initPageScroll() {

        /*=============================================
        =            REquestion animation Frame       =
        =============================================*/

        function windowScrollLogic() {
            pageOffset = window.pageYOffset;

            if (pageOffset >= stickyOffset) {

                $stickyMenu.addClass(isStickyClass);

                pageOffset >= anchoredBottomOffset ? $stickyMenu.addClass(isAnchoredBottomClass) : $stickyMenu.removeClass(isAnchoredBottomClass);
            } else {
                $stickyMenu.removeClass(isStickyClass + ' ' + isAnchoredBottomClass);
            }

            rAFTicker = false;
        }

        function requestTicker() {
            if (!rAFTicker) {
                requestAnimationFrame(windowScrollLogic);
                rAFTicker = true;
            }
        }

        function attachScrollEvent() {
            // only listen for scroll events
            window.addEventListener('scroll', requestTicker, false);
        }

        function removeScrollEvent() {
            //remove ScrollEvent
            window.removeEventListener('scroll', requestTicker, false);
        }

        //setup initial values
        attachScrollEvent();

        /*=====  End RAF Animation  ======*/
    };

    initModule = function initModule() {

        //initialize Variables
        $stickyModule = $('.js-sticky-share');
        $stickyMenu = $stickyModule.find('.js-sticky-share-tools');

        //setup classes for is in view header
        globalVars = require('./variables');

        //Dom Ready
        document.addEventListener('DOMContentLoaded', function () {

            setTimeout(function () {
                setupWindowOffsets();
                initPageScroll();
            }, 10);
        });

        globalVars.windowResize.add(function () {
            setupWindowOffsets();
        });
    };

    return {
        init: initModule,
        update: setupWindowOffsets
    };
}();

module.exports = stickyShare;

},{"./variables":67}],64:[function(require,module,exports){
'use strict';

function ToggleMenu(toggleEl, classOptions) {

    this.$toggleMenu = toggleEl;
    this.$expandableMenu = this.$toggleMenu.find('.' + classOptions.expandableMenu);

    this.classNames = classOptions || {
        triggerClass: 'js-trigger',
        expandableMenu: 'js-menu',
        showOptions: 'show-menu',
        navOptionsClass: 'js-option',
        selectedOptionClass: 'is-selected',
        navOptions: 'js-nav',
        updateToggleLabel: false
    };

    this.bindEvents();
}

ToggleMenu.prototype.updateMobileLabel = function mobileLabel($navNode) {
    this.$toggleMenu.find('.' + this.classNames.triggerClass).text($navNode.text());
};

ToggleMenu.prototype.updateNavState = function updateClasses($navOption) {

    this.$toggleMenu.find('.' + this.classNames.selectedOptionClass).removeClass(this.classNames.selectedOptionClass);

    $navOption.parent().addClass(this.classNames.selectedOptionClass);

    if (this.classNames.updateToggleLabel) {

        this.updateMobileLabel($navOption);
    }
};

ToggleMenu.prototype.toggleMenu = function toggleMenu() {
    var _self = this;

    if (_self.$toggleMenu.data('is-expanded')) {

        _self.$toggleMenu.removeClass(_self.classNames.showOptions);

        _self.$toggleMenu.attr('aria-expanded', false).data('is-expanded', false);

        var $trigger = $('.' + _self.classNames.triggerClass);
        $trigger.attr('aria-expanded', false);

        var $expandableMenu = $('.' + _self.classNames.expandableMenu);
        $expandableMenu.attr('aria-hidden', true);

        var $navOptions = $('.' + _self.classNames.navOptions);
        $navOptions.attr('tabindex', -1);
    } else {
        _self.$toggleMenu.addClass(_self.classNames.showOptions);

        _self.$toggleMenu.attr('aria-expanded', true).data('is-expanded', true);

        var $trigger = $('.' + _self.classNames.triggerClass);
        $trigger.attr('aria-expanded', true);

        var $expandableMenu = $('.' + _self.classNames.expandableMenu);
        $expandableMenu.attr('aria-hidden', false);

        var $navOptions = $('.' + _self.classNames.navOptions);
        $navOptions.attr('tabindex', 1);
    }
};

ToggleMenu.prototype.bindEvents = function bind() {
    var _self = this;

    //set data attribute to keep track of if toggle is expanded or not
    if (typeof _self.$toggleMenu.data('is-expanded') === 'undefined') {

        _self.$toggleMenu.data('is-expanded', false);
    }

    if (_self.$toggleMenu.data('is-expanded')) {

        //set active class if expanded by default
        _self.$toggleMenu.addClass(_self.classNames.showOptions);
    }

    //Initialize event listeners to the toggle button and navigation items
    _self.$toggleMenu.on('click.toggleMenu', '.' + _self.classNames.triggerClass, function (ev) {
        ev.stopPropagation();

        _self.toggleMenu();
    });

    if (_self.classNames.navOptionsClass) {
        _self.$toggleMenu.on('click.toggleMenuButtons', '.' + _self.classNames.navOptionsClass, function (ev) {
            ev.stopPropagation();

            _self.toggleMenu();
            _self.updateNavState($(this));
        });
    }
};

module.exports = ToggleMenu;

},{}],65:[function(require,module,exports){
'use strict';

module.exports = function () {
  'use strict';

  var topicDetail = document.getElementById('topic-detail'),


  //modules
  scrollspy;

  if (!topicDetail) {
    return;
  }

  //scrollspy initialization
  scrollspy = require('./scrollspy');
  scrollspy.init();
  require('./scroll-on-load');
}();

},{"./scroll-on-load":56,"./scrollspy":57}],66:[function(require,module,exports){
'use strict';

window.vueAppStates = { relatedExperience: false, perspectivesNewsEvents: false };

window.vueAppsLoaded = function () {
    var relatedExperience = document.getElementById('related-experience-app');
    var perspectivesNewsEvents = document.getElementById('related-articles-app');

    if (relatedExperience || perspectivesNewsEvents) {
        for (var key in window.vueAppStates) {
            if (!window.vueAppStates[key]) return false;
        }
    }

    return true;
};

//helper functions
window.helperUtils = {
    getDocDimen: function getDocDimen() {
        var winDimen = {};

        winDimen.height = window.innerHeight;
        winDimen.width = window.innerWidth;

        return winDimen;
    }
};

window.parseQueryString = function (str) {
    if (typeof str !== 'string') {
        return {};
    }
    str = str.trim().replace(/^\?/, '');
    if (!str) {
        return {};
    }
    return str.trim().split('&').reduce(function (ret, param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        ret[parts[0]] = parts[1] === undefined ? null : decodeURIComponent(parts[1]);
        return ret;
    }, {});
};

window.getQueryParams = function () {
    var search = window.location.search.substring(1);
    return search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
    }) : {};
};

/**
 * Get the value of a querystring
 * @param  {String} field The field to get the value of
 * @param  {String} url   The URL to get the value from (optional)
 * @return {String}       The field value
 */
window.getQueryString = function (field, url) {
    var href = url ? url : window.location.href;
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
};

window.updateQueryString = function (uri, key, value) {
    // Remove the hash before operating on the URL
    var i = uri.indexOf('#');
    var hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (!value) {
        // Remove the key value pair if the value is empty
        uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
        if (uri.slice(-1) === '?') {
            uri = uri.slice(0, -1);
        }
        // Replace first occurrence of & by ? if no ? is present
        if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
    } else if (uri.match(re)) {
        uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        uri = uri + separator + key + "=" + value;
    }
    return uri + hash;
};

// https://stackoverflow.com/questions/1309483/redirect-user-to-current-page-with-some-querystring-using-javascript
window.reloadWithQueryStringVars = function (queryStringVars) {
    var existingQueryVars = location.search ? location.search.substring(1).split("&") : [],
        currentUrl = location.search ? location.href.replace(location.search, "") : location.href,
        newQueryVars = {},
        newUrl = currentUrl + "?";

    if (existingQueryVars.length > 0) {
        for (var i = 0; i < existingQueryVars.length; i++) {
            var pair = existingQueryVars[i].split("=");
            newQueryVars[pair[0]] = pair[1];
        }
    }
    if (queryStringVars) {
        for (var queryStringVar in queryStringVars) {
            newQueryVars[queryStringVar] = queryStringVars[queryStringVar];
        }
    }
    if (newQueryVars) {
        for (var newQueryVar in newQueryVars) {
            newUrl += newQueryVar + "=" + newQueryVars[newQueryVar] + "&";
        }
        newUrl = newUrl.substring(0, newUrl.length - 1);
        window.open(newUrl, '_blank');
    } else {
        window.location.href = location.href;
    }
};

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller
// fixes from Paul Irish and Tino Zijdel
(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
            callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
    };

    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
    };
})();

},{}],67:[function(require,module,exports){
'use strict';

var globalVars = {

    device: {
        isIpad: null,
        isIphone: null
    },

    elementStates: {
        headerHeight: null
    },

    elements: {
        $siteHeader: $('.js-site-header')
    },

    isMobile: false,
    isMobileLandscape: false,
    isTabletMax: false
};

var setupValues,

//responsive media query function
mqMobile;

globalVars.elementStates = {
    headerHeight: globalVars.elements.$siteHeader.outerHeight()
};

//setup globalMagicController
globalVars.magicController = new ScrollMagic.Controller();

globalVars.sceneCollection = {};

setupValues = function setupValues(tableLanscape) {

    globalVars.tableLanscape = tableLanscape;
    globalVars.isTabletMax = window.innerWidth < 901 ? true : false;
    globalVars.isMobile = window.innerWidth < 767 ? true : false;
    globalVars.isMobileLandscape = window.innerWidth < 630 ? true : false;

    globalVars.elementStates.headerHeight = Math.ceil(globalVars.elements.$siteHeader.outerHeight());
};

//make sure this matches css
mqMobile = window.matchMedia('(max-width: 1024px)');

mqMobile.matches ? setupValues(true) : setupValues(false);

mqMobile.addListener(function (changed) {
    changed.matches ? setupValues(true) : setupValues(false);
});

navigator.userAgent.match(/iPhone/i) ? globalVars.device.isIphone = true : globalVars.device.isIphone = false;
navigator.userAgent.match(/iPod/i) ? globalVars.device.isIpad = true : globalVars.device.isIpad = false;

globalVars.windowResize = function () {

    var callbacks = [],
        running = false;

    // fired on resize event
    function resize() {

        if (!running) {
            running = true;

            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(runCallbacks);
            } else {
                setTimeout(runCallbacks, 66);
            }
        }
    }

    // run the actual callbacks
    function runCallbacks() {

        callbacks.forEach(function (callback) {
            callback();
        });

        running = false;
    }

    // adds callback to loop
    function addCallback(callback) {

        if (callback) {
            callbacks.push(callback);
        }
    }

    return {
        // public method to add additional callback
        add: function add(callback) {
            if (!callbacks.length) {
                window.addEventListener('resize', resize);
            }
            addCallback(callback);
        }
    };
}();

module.exports = globalVars;

},{}],68:[function(require,module,exports){
'use strict';

var aroundCorner;

aroundCorner = function () {
    var $aroundCorner, $reel, $frame, $tileNodes, beltWidth, frameHeight, setupParallaxAnimation, updateParallaxValues, triggerHook, magicController, resizeControllerLogic, globalVars, windowResize, initializeModule, inViewPlatform;

    //globalVariables
    globalVars = require('./variables');
    windowResize = globalVars.windowResize;

    setupParallaxAnimation = function setupParallaxAnimation() {

        if (!$frame && !$tileNodes) return;

        //60 is horizontal padding of pagewrapper
        if ($frame.width() - 60 > beltWidth || $tileNodes.length === 1) {
            if (!!magicController) {
                magicController.destroy(true);
                magicController = null;
            }
            $aroundCorner.css('height', '');
            return;
        }

        //setup frame
        frameHeight = window.innerHeight * ($tileNodes.length - 1);

        $aroundCorner.height(frameHeight);

        magicController = new ScrollMagic.Controller();

        var tweenOffset = -1 * $tileNodes.length * $tileNodes.eq(0).outerWidth() + $reel.width();

        tweenOffset = tweenOffset - (80 * ($tileNodes.length - 1) + 20); //80 is margin, while 15 is the side padding

        inViewPlatform = new ScrollMagic.Scene({
            triggerElement: $aroundCorner[0],
            triggerHook: triggerHook,
            duration: frameHeight - $reel.height() - 80,
            offset: globalVars.elementStates.headerHeight * -1.5
        }).setPin($frame[0]).setTween($reel[0], { x: tweenOffset + 'px' }).addTo(magicController);
    };

    updateParallaxValues = function updateParallaxValues() {

        frameHeight = window.innerHeight * ($tileNodes.length - 1);

        $aroundCorner.height(frameHeight);

        var tweenOffset = -1 * $tileNodes.length * $tileNodes.eq(0).outerWidth() + $reel.width();

        tweenOffset = tweenOffset - (80 * ($tileNodes.length - 1) + 20); //80 is margin, while 15 is the side padding

        inViewPlatform.duration(frameHeight - $reel.height() - 80);

        inViewPlatform.setTween($reel[0], { x: tweenOffset + 'px' });
    };

    resizeControllerLogic = function resizeControllerLogic() {

        if (globalVars.tableLanscape) {
            if (!!magicController) {
                magicController.destroy(true);
                magicController = null;
                $aroundCorner.css('height', '');
            }
        } else {
            !magicController ? setupParallaxAnimation() : updateParallaxValues();
        }
    };

    windowResize.add(resizeControllerLogic);

    initializeModule = function initializeModule($module) {
        $aroundCorner = $module ? $module : $('.js-vertical-corner');

        if ($aroundCorner.length) {
            triggerHook = $aroundCorner.data('trigger-hook') ? $aroundCorner.data('trigger-hook') : 0;
            $tileNodes = $aroundCorner.find('.js-corner-tile');
            $reel = $aroundCorner.find('.js-reel');
            $frame = $aroundCorner.find('.js-frame');

            if ($tileNodes.length <= 1) {
                return;
            }

            beltWidth = $tileNodes.length < 2 ? $tileNodes.width : $tileNodes.eq(0).width() * $tileNodes.length + parseInt(window.getComputedStyle($tileNodes.eq(1)[0], null).getPropertyValue("margin-left"), 10) * ($tileNodes.length - 1);

            resizeControllerLogic();

            //https://coderwall.com/p/hlqqia/ie-fix-for-jumpy-fixed-bacground 
            // fix for scrollmagic in ie
            if (navigator.userAgent.match(/Trident\/7\./)) {
                // if IE
                $('body').on("mousewheel", function () {
                    // remove default behavior
                    event.preventDefault();

                    //scroll without smoothing
                    var wheelDelta = event.wheelDelta;
                    var currentScrollPosition = window.pageYOffset;
                    window.scrollTo(0, currentScrollPosition - wheelDelta);
                });
            }
        } else {
            return;
        }
    };

    return {
        init: initializeModule
    };
}();

module.exports = aroundCorner;

},{"./variables":67}],69:[function(require,module,exports){
'use strict';

window.Headroom = require('headroom.js');

var header = {

    init: function init() {
        this.siteheader = document.querySelector('.siteheader');
        this.navigation = document.querySelector('#site-navigation');
        this.search = document.querySelector('.globalsearch');

        if (!this.siteheader) {
            return;
        }

        var headroom = new Headroom(this.siteheader, {
            offset: 300,
            classes: {
                initial: 'siteheader--headroom',
                pinned: 'siteheader--pinned',
                unpinned: 'siteheader--unpinned',
                top: 'siteheader--top',
                notTop: 'siteheader--not-top',
                bottom: 'siteheader--bottom',
                notBottom: 'siteheader--not-bottom'
            },
            onUnpin: function onUnpin() {
                //close all nav items

                if (header.is_nav_open()) {
                    //don't unpin if nav/subnav or search is open
                    this.elem.classList.remove(this.classes.unpinned);
                    this.elem.classList.add(this.classes.pinned);
                } else {
                    this.elem.classList.add(this.classes.unpinned);
                    this.elem.classList.remove(this.classes.pinned);
                }
            },
            tolerance: {
                up: 5,
                down: 0
            }
        });
        headroom.init();
    },
    is_nav_open: function is_nav_open() {

        var subnav_open = document.querySelector('.nav__sub.is-open');

        // test nav
        if (this.navigation.classList.contains('is-open')) {
            return true;
        } else if (this.search.classList.contains('is-open')) {
            return true;
        } else if (subnav_open) {
            return true;
        } else {
            return false;
        }
    }
};

var $siteSearchInput = $('#global-search-box');
var $siteSearchButton = $('#global-search-button');

$siteSearchButton.on('click', function () {
    var query = $siteSearchInput.val();
    var landingPage = $siteSearchInput.attr('data-landing');
    window.location.href = landingPage + '?query=' + encodeURIComponent(query);
    return false;
});

$siteSearchInput.on('keyup', function (e) {
    if (e.keyCode == 13) {
        var query = $siteSearchInput.val();
        var landingPage = $siteSearchInput.attr('data-landing');
        window.location.href = landingPage + '?query=' + encodeURIComponent(query);
        return false;
    }
});

var $peopleSearchInput = $('#people-search-input');
var $peopleSearchButton = $('#people-search-button');

$peopleSearchButton.on('click', function () {
    var query = $peopleSearchInput.val();
    var peopleLanding = $peopleSearchInput.attr('data-landing');
    window.location.href = peopleLanding + '?name=' + encodeURIComponent(query);
    return false;
});

$peopleSearchInput.on('keyup', function (e) {
    if (e.keyCode == 13) {
        var query = $peopleSearchInput.val();
        var peopleLanding = $peopleSearchInput.attr('data-landing');
        window.location.href = peopleLanding + '?name=' + encodeURIComponent(query);
        return false;
    }
});

var $capabilitiesSearchInput = $('#capabilities-search-input');
var $capabilitiesSearchButton = $('#capabilities-search-button');

$capabilitiesSearchButton.on('click', function () {
    var query = $capabilitiesSearchInput.val();
    var capabilitiesLanding = $capabilitiesSearchInput.attr('data-landing');
    window.location.href = capabilitiesLanding + '?page=1&scroll=550&keyword=' + encodeURIComponent(query);
    return false;
});

$capabilitiesSearchInput.on('keyup', function (e) {
    if (e.keyCode == 13) {
        var query = $capabilitiesSearchInput.val();
        var capabilitiesLanding = $capabilitiesSearchInput.attr('data-landing');
        window.location.href = capabilitiesLanding + '?page=1&scroll=550&keyword=' + encodeURIComponent(query);
        return false;
    }
});

header.init();

module.exports = header;

},{"headroom.js":16}],70:[function(require,module,exports){
'use strict';

window.Flickity = require('flickity');

var herocarousel = {

    init: function init() {

        var hero_carousel = document.querySelector('.hero-carousel');
        var hero_carousel_cell = '.hero-carousel__cell';
        var hero_carousel_cell_count = document.querySelectorAll(hero_carousel_cell).length;
        var hero_button = document.querySelector('.js-hero-carousel__button');

        if (!hero_carousel || hero_carousel_cell_count < 2) {
            return;
        }

        var autoplay_duration = 0; // if zero then it will not autoplay

        if (hero_carousel.dataset.autoplay) {
            autoplay_duration = hero_carousel.dataset.autoplay * 1000; //convert to milliseconds
        }

        var hero_flkty = new Flickity(hero_carousel, {
            autoPlay: autoplay_duration,
            cellAlign: 'left',
            cellSelector: hero_carousel_cell,
            groupCells: true,
            pageDots: true,
            pauseAutoPlayOnHover: false,
            prevNextButtons: false,
            wrapAround: true
        });

        window.hero_flkty = hero_flkty;

        var hero_paused = false;
        var paused_style = 'is-paused';

        if (autoplay_duration > 0) {

            hero_button.addEventListener('click', function () {

                if (hero_paused === true) {
                    hero_flkty.playPlayer();
                    hero_flkty.next();
                    this.classList.remove(paused_style);
                    hero_paused = false;
                } else {
                    hero_flkty.pausePlayer();
                    this.classList.add(paused_style);
                    hero_paused = true;
                }
            });

            hero_flkty.on('pointerDown', function () {

                if (hero_paused !== true) {
                    hero_button.classList.add(paused_style);
                    hero_paused = true;
                }
            });

            hero_flkty.on('select', function (index) {

                if (hero_flkty.player.state == 'playing') {
                    return;
                }

                if (hero_paused !== true) {
                    hero_button.classList.add(paused_style);
                    hero_paused = true;
                }
            });
        } else {
            hero_button.classList.add('hero-carousel__button--hidden');
        }

        // fix on ios 9
        hero_flkty.on('dragStart', function () {
            document.ontouchmove = function (e) {
                e.preventDefault();
            };
        });

        hero_flkty.on('dragEnd', function () {
            document.ontouchmove = function () {
                return true;
            };
        });
    }
};

herocarousel.init();

module.exports = herocarousel;

},{"flickity":9}],71:[function(require,module,exports){
'use strict';

require('./header');
require('./language-menu');
require('./navigation');
require('./hero-carousel');
require('./region-carousel');
require('./quote-carousel');

},{"./header":69,"./hero-carousel":70,"./language-menu":72,"./navigation":73,"./quote-carousel":74,"./region-carousel":75}],72:[function(require,module,exports){
'use strict';

var language_menu = {

    init: function init() {
        this.menu = document.querySelector('.js-language-menu');
        this.menu_button = document.querySelector('.js-language-menu__button');
        this.menu_links = document.querySelectorAll('.language-menu__link');
        this.menu_options = document.querySelector('.language-menu__options');

        if (!this.menu || !this.menu_button) {
            return;
        }

        this.menu_button.addEventListener('click', function (e) {
            e.preventDefault();

            if (language_menu.menu_options.getAttribute('aria-hidden') === 'true') {
                language_menu.open_menu();
            } else {
                language_menu.close_menu();
            }
        });
    },

    open_menu: function open_menu() {
        this.menu.classList.add('is-open');
        this.menu_options.setAttribute('aria-hidden', false);
        this.menu_button.setAttribute('aria-expanded', true);
        this.set_focus('0');
    },

    close_menu: function close_menu() {
        this.menu.classList.remove('is-open');
        this.menu_options.setAttribute('aria-hidden', true);
        this.menu_button.setAttribute('aria-expanded', false);
        this.set_focus('-1');
    },

    set_focus: function set_focus(state) {

        for (var i = 0; i < this.menu_links.length; i++) {
            var link = this.menu_links[i];
            var tabindex = link.setAttribute('tabindex', state);
        }
    }
};

language_menu.init();

module.exports = language_menu;

},{}],73:[function(require,module,exports){
'use strict';

var navigation = {

    init: function init() {
        this.siteheader = document.querySelector('.siteheader');
        this.nav_container = document.querySelector('.nav');
        this.search_container = document.querySelector('.globalsearch');
        this.nav_secondary = document.querySelector('#nav-secondary');
        if (!this.nav_container) {
            return;
        }

        this.toggle_nav.init();
        this.toggle_subnav.init();
        this.toggle_search.init();

        //esc key event
        document.addEventListener('keyup', function (e) {
            if (e.which === 27) {
                navigation.toggle_nav.close_nav();
                navigation.toggle_subnav.close_active_subnavs();
                navigation.toggle_search.close_search();
            }
        });
    },

    close_all: function close_all() {
        navigation.toggle_nav.close_nav();
        navigation.toggle_subnav.close_active_subnavs();
        navigation.toggle_search.close_search();
    },

    pause_hero_carousel: function pause_hero_carousel(state) {

        if (window.hero_flkty) {
            if (state) {
                window.hero_flkty.pausePlayer();
            } else {
                window.hero_flkty.unpausePlayer();
            }
        }
    },

    get_cookie_object: function get_cookie_object() {
        if (!this.cookie) {
            this.cookie = document.querySelector('#usercentrics-button');
        }
    },

    toggle_search: {

        init: function init() {

            this.search_toggle_button = document.querySelector('.js-search-toggle');
            this.mobile_search_toggle_button = document.querySelector('.js-mobile-search-toggle');
            this.search_form = document.querySelector('.js-globalsearch__form');
            this.search_input = document.querySelector('#global-search-box');

            if (!navigation.search_container) {
                return;
            }

            this.search_toggle_button.addEventListener('click', function (e) {
                e.preventDefault();

                if (navigation.search_container.classList.contains('is-open')) {
                    navigation.toggle_search.close_search();
                } else {
                    navigation.toggle_search.open_search();
                    navigation.toggle_search.search_toggle_button.blur();
                }
            });

            this.mobile_search_toggle_button.addEventListener('click', function (e) {
                e.preventDefault();

                if (navigation.search_container.classList.contains('is-open')) {
                    navigation.toggle_search.close_search();
                } else {
                    navigation.toggle_search.open_search();
                    navigation.toggle_search.search_toggle_button.blur();
                }
            });
        },

        open_search: function open_search() {

            this.search_toggle_button.classList.add('is-active');
            navigation.search_container.classList.add('is-open');

            // set focus
            this.search_input.focus();

            // set aria
            this.search_form.setAttribute('aria-hidden', 'false');
            this.search_toggle_button.setAttribute('aria-expanded', 'true');

            // close subnav and secondary navs
            navigation.toggle_subnav.close_active_subnavs();
            navigation.toggle_nav.close_nav();

            // pause carousel
            navigation.pause_hero_carousel(true);
        },

        close_search: function close_search() {

            this.search_toggle_button.classList.remove('is-active');
            this.search_toggle_button.blur();

            // set aria
            this.search_form.setAttribute('aria-hidden', 'true');
            this.search_toggle_button.setAttribute('aria-expanded', 'false');

            if (navigation.search_container) {
                navigation.search_container.classList.remove('is-open');
            }

            // un pause carousel
            navigation.pause_hero_carousel(false);
        }
    },

    toggle_nav: {

        init: function init() {

            this.nav_toggle_button = document.querySelector('.js-nav-toggle');

            if (!this.nav_toggle_button) {
                return;
            }

            this.nav_toggle_button.addEventListener('click', function (e) {
                e.preventDefault();

                if (navigation.nav_container.classList.contains('is-open')) {
                    navigation.toggle_nav.close_nav();
                } else {
                    navigation.toggle_nav.open_nav();
                }
            });
        },

        open_nav: function open_nav() {

            this.nav_toggle_button.classList.add('is-active');
            // navigation.nav_container.classList.add('nav--has-transition');
            navigation.nav_container.classList.add('is-open');

            // set focus
            if (window.matchMedia && window.matchMedia('(min-width: 1300px)').matches) {
                navigation.nav_secondary.setAttribute('tabindex', '-1');
                navigation.nav_secondary.focus();
            } else if (window.matchMedia && window.matchMedia('(max-width: 1000px)').matches) {
                navigation.get_cookie_object();
                navigation.cookie.classList.add('hide-cookie');
            }

            // close subnavs
            navigation.toggle_subnav.close_active_subnavs();

            // close search
            navigation.toggle_search.close_search();

            // pause carousel
            navigation.pause_hero_carousel(true);
        },

        close_nav: function close_nav() {

            if (!this.nav_toggle_button) {
                return;
            }

            this.nav_toggle_button.classList.remove('is-active');
            // navigation.nav_container.classList.remove('nav--has-transition');
            navigation.nav_container.classList.remove('is-open');
            navigation.nav_secondary.removeAttribute('tabindex');

            if (window.matchMedia && window.matchMedia('(max-width: 1000px)').matches) {
                navigation.get_cookie_object();
                navigation.cookie.classList.remove('hide-cookie');
            }

            // un pause carousel
            navigation.pause_hero_carousel(false);
        }
    },

    toggle_subnav: {

        init: function init() {
            this.sub_nav_links = document.querySelectorAll('.js-nav-has-subnav');

            //sub nav link event
            for (var i = 0; i < this.sub_nav_links.length; i++) {
                var sub_nav_link = this.sub_nav_links[i];
                navigation.toggle_subnav.bind_links(sub_nav_link);
            }
        },

        bind_links: function bind_links(sub_nav_link) {

            var event_binding = function event_binding(target) {
                // this.close_active_subnavs(target);
                // this.open_subnav(target);

                if (target.classList.contains('is-active')) {
                    navigation.toggle_subnav.close_subnav(target);
                } else {
                    navigation.toggle_subnav.open_subnav(target);
                }
            };

            sub_nav_link.addEventListener('click', function (e) {
                var target = e.currentTarget;

                if (window.matchMedia && window.matchMedia('(min-width: 1300px)').matches) {
                    e.preventDefault();
                    event_binding(target);
                }
            });

            sub_nav_link.addEventListener('keydown', function (e) {
                var target = e.currentTarget;

                if (e.which !== 32) {
                    return;
                }

                if (window.matchMedia && window.matchMedia('(min-width: 1300px)').matches) {
                    e.preventDefault();
                    event_binding(target);
                }
            });
        },

        open_subnav: function open_subnav(target) {
            var target_subnav = target.nextElementSibling;

            var current_page = document.querySelector('.is-current-page');
            if (current_page) {
                current_page.classList.add('is-current-page--hidden');
            }
            // close secondary nav
            navigation.toggle_nav.close_nav();

            // close search
            navigation.toggle_search.close_search();

            // close open subnavs
            navigation.toggle_subnav.close_active_subnavs(target);

            // open subnav
            target.classList.add('is-active');
            target_subnav.classList.add('is-open');

            // pause carousel
            navigation.pause_hero_carousel(true);
        },

        close_subnav: function close_subnav(target) {
            var target_subnav = target.nextElementSibling;

            var current_page = document.querySelector('.is-current-page');
            if (current_page) {
                current_page.classList.remove('is-current-page--hidden');
            }

            // close subnav
            target.blur();
            target.classList.remove('is-active');
            target_subnav.classList.remove('is-open');

            // unpause carousel
            navigation.pause_hero_carousel(false);
        },

        close_active_subnavs: function close_active_subnavs(target) {
            // close open subnavs
            for (var i = 0; i < this.sub_nav_links.length; i++) {

                var link = this.sub_nav_links[i];

                if (target !== link) {
                    var subnav = link.nextElementSibling;
                    link.classList.remove('is-active');
                    subnav.classList.remove('is-open');
                    link.blur();
                }
            }
        }
    }
};

navigation.init();

module.exports = navigation;

},{}],74:[function(require,module,exports){
'use strict';

window.Flickity = require('flickity');

var quotecarousel = {

    init: function init() {

        var quote_carousel = document.querySelector('.quote-carousel');
        var quote_carousel_cell = '.quote-carousel__cell';
        var quote_carousel_cell_count = document.querySelectorAll(quote_carousel_cell).length;

        if (!quote_carousel || quote_carousel_cell_count < 2) {
            return;
        }

        var autoplay_duration = 0; // if zero then it will not autoplay

        if (quote_carousel.dataset.autoplay) {
            autoplay_duration = quote_carousel.dataset.autoplay * 1000; //convert to milliseconds
        }

        var flkty = new Flickity(quote_carousel, {
            autoPlay: autoplay_duration,
            cellAlign: 'left',
            cellSelector: quote_carousel_cell,
            groupCells: true,
            pageDots: false,
            prevNextButtons: true,
            wrapAround: true
        });

        // fix on ios 9
        flkty.on('dragStart', function () {
            document.ontouchmove = function (e) {
                e.preventDefault();
            };
        });

        flkty.on('dragEnd', function () {
            document.ontouchmove = function () {
                return true;
            };
        });
    }
};

quotecarousel.init();

module.exports = quotecarousel;

},{"flickity":9}],75:[function(require,module,exports){
'use strict';

window.Flickity = require('flickity');

var regioncarousel = {

    init: function init() {

        var region_carousel = document.querySelector('.region-carousel');
        var region_carousel_cell = '.region-carousel__cell';
        var region_carousel_cell_count = document.querySelectorAll(region_carousel_cell).length;

        if (!region_carousel || region_carousel_cell_count < 2) {
            return;
        }

        var autoplay_duration = 0; // if zero then it will not autoplay

        if (region_carousel.dataset.autoplay) {
            autoplay_duration = region_carousel.dataset.autoplay * 1000; //convert to milliseconds
        }

        var flkty = new Flickity(region_carousel, {
            autoPlay: autoplay_duration,
            cellAlign: 'left',
            cellSelector: region_carousel_cell,
            groupCells: true,
            pageDots: false,
            prevNextButtons: true,
            wrapAround: true,
            watchCSS: true
        });

        // fix on ios 9
        flkty.on('dragStart', function () {
            document.ontouchmove = function (e) {
                e.preventDefault();
            };
        });

        flkty.on('dragEnd', function () {
            document.ontouchmove = function () {
                return true;
            };
        });
    }
};

regioncarousel.init();

module.exports = regioncarousel;

},{"flickity":9}]},{},[19]);
